

import React, { useEffect, useState } from 'react';
import { AlertCircle, ChevronRight, ArrowLeft, Filter, Download, CheckCircle, XCircle, Loader2, FileSpreadsheet, Printer, FileText, Eye, X, Info, BarChart2, CheckSquare, Lock } from 'lucide-react';
import TabelPreviewPAK from './TabelPreviewPAK'; 
import DetailPegawaiCard from './DetailPegawaiCard'; 

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';

const BASE_URL = process.env.REACT_APP_API_URL;

const formatNum = (value, decimals = 3) => {
  const num = Number(value);
  return isNaN(num) ? (0).toFixed(decimals) : num.toFixed(decimals);
};

const safeParseDate = (inputDate) => {
    if (!inputDate) return null;
    if (inputDate instanceof Date) {
        if (isNaN(inputDate.getTime())) return null;
        return { year: inputDate.getFullYear(), month: inputDate.getMonth() + 1, day: inputDate.getDate() };
    }
    const dateStr = String(inputDate).trim();
    if (dateStr.includes('/')) {
        const parts = dateStr.split('/');
        if (parts.length >= 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10); 
            const year = parseInt(parts[2], 10);
            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) return { year, month, day };
        }
    }
    const d = new Date(dateStr);
    if (!isNaN(d.getTime())) return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    if (dateStr.includes('-')) {
        const parts = dateStr.split('T')[0].split('-');
        if (parts.length >= 3) {
            let year = parseInt(parts[0], 10);
            let month = parseInt(parts[1], 10); 
            let day = parseInt(parts[2], 10);
            if (year < 1000) { 
                day = parseInt(parts[0], 10);
                year = parseInt(parts[2], 10); 
            }
            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) return { year, month, day };
        }
    }
    return null;
};

// ARRAY NAMA BULAN UNTUK CETAK PERIODE SKP
const monthNames = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

const GOLONGAN_MAP = {
  'III/a': { koef: 12.5, akLama: 50, jenjang: 100 }, 'III/b': { koef: 12.5, akLama: 50, jenjang: 100 },
  'III/c': { koef: 25, akLama: 100, jenjang: 200 }, 'III/d': { koef: 25, akLama: 100, jenjang: 200 },
  'IV/a': { koef: 37.5, akLama: 150, jenjang: 450 }, 'IV/b': { koef: 37.5, akLama: 150, jenjang: 450 }, 'IV/c': { koef: 37.5, akLama: 150, jenjang: 450 },
  'IV/d': { koef: 50, akLama: 200, jenjang: -1 }, 'IV/e': { koef: 50, akLama: 0, jenjang: -1 }
};

// ==========================================
// HELPER NORMALISASI DATA (KECAMATAN & JABATAN)
// ==========================================
const normalizeKecamatan = (kec) => {
    let k = (kec || '').trim().toLowerCase();
    if (k === '' || k === '-') return 'Sudindik JT 2';
    if (k === 'kramatjati' || k === 'kramat jati') return 'Kramat Jati';
    if (k === 'pasarrebo' || k === 'pasar rebo') return 'Pasar Rebo';
    return k.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

const normalizeJabatan = (jab) => {
    let j = (jab || '').trim();
    if (j === '' || j === '-') return 'Belum Diisi';
    return j.toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

const VerifikasiPAK = () => {
  const [view, setView] = useState('list');
  const [submissions, setSubmissions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [calculation, setCalculation] = useState(null);
  
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [filters, setFilters] = useState({ 
      namaNip: '', golongan: '', kecamatan: '', unitKerja: '', 
      status: '', statusAk: '', jenisPak: '', nomorSurat: '', 
      tglCetak: '', uploadStatus: '', jabatan: '', cetakStatus: '',
      tglUsul: '',      // TAMBAHAN BARU
      tglValidasi: ''   // TAMBAHAN BARU
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'tgl_usul', direction: 'desc' });
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [kickedModal, setKickedModal] = useState({ show: false, taken_by: '' });
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRekapModal, setShowRekapModal] = useState(false);
// Cari state pengaturan cetak Anda dan tambahkan 2 baris ini:

  // STATE BARU: GENERATE TOKEN UNIK PER BROWSER TAB SAAT HALAMAN DIBUKA
  const [myLockToken] = useState(() => Math.random().toString(36).substring(2, 15) + Date.now().toString(36));
const [lockWarning, setLockWarning] = useState({ show: false, lockedBy: '', pendingItem: null });
  const [isEditingBio, setIsEditingBio] = useState(false);
  const [editedBio, setEditedBio] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);

  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '', actionBtn: '', onConfirm: null });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 4000);
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchStartNum, setBatchStartNum] = useState(1);
  
  const [showBulkNipModal, setShowBulkNipModal] = useState(false);
  const [bulkNips, setBulkNips] = useState('');

  const handleSelectByNips = () => {
      if (!bulkNips.trim()) {
          showToast("Silakan masukkan NIP terlebih dahulu", "error");
          return;
      }
      
      // Memisahkan NIP jika user paste dengan baris baru (enter), koma, atau spasi
      const nipList = bulkNips.split(/[\n, \t]+/).map(n => n.trim()).filter(n => n !== '');
      
      const matchedIds = submissions
          .filter(sub => !sub.is_empty && nipList.includes(sub.nip))
          .map(sub => sub.pak_id);
          
      if (matchedIds.length === 0) {
          showToast("Tidak ada data NIP yang cocok ditemukan", "error");
          return;
      }

      setSelectedRows(matchedIds); // Centang semua baris yang cocok
      setShowBulkNipModal(false);
      setBulkNips('');
      showToast(`Berhasil mencentang ${matchedIds.length} pegawai! Silakan klik Cetak/Export.`, "success");
  };
  
  const [tanggalTtd, setTanggalTtd] = useState(new Date().toISOString().split('T')[0]);
  const [useExistingNumber, setUseExistingNumber] = useState(true);
  const [printTteMode, setPrintTteMode] = useState('with_tte');
  const [useExistingPrintDate, setUseExistingPrintDate] = useState(true);

  // Ambil bagian YYYY-MM-DD tanpa mengubah tanggal karena timezone browser.
  const normalizePrintDate = (value) => {
    if (!value) return '';

    const raw = String(value);
    const isoMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (isoMatch) return isoMatch[1];

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };
  const getHighestSuratNum = () => {
    let maxNum = 0;
    submissions.forEach(sub => {
      if (sub.nomor_surat && sub.nomor_surat !== '-' && sub.nomor_surat.includes('/KG.04.04')) {
        const numPart = parseInt(sub.nomor_surat.split('/')[0], 10);
        if (!isNaN(numPart) && numPart > maxNum) { maxNum = numPart; }
      }
    });
    return maxNum;
  };

  const handleOpenBatchModal = () => {
    setBatchStartNum(getHighestSuratNum() + 1);
    setShowBatchModal(true);
  };

  const [isClosed, setIsClosed] = useState(false);
  const [printQueue, setPrintQueue] = useState([]);
  const [isProcessingZip, setIsProcessingZip] = useState(false);

  // FAST MODE:
  // hanya 1 PAK yang dirender ke DOM pada satu waktu.
  // Ini menghindari browser merender ratusan preview PAK sekaligus.
  const [activePrintItem, setActivePrintItem] = useState(null);
  const [progressStatus, setProgressStatus] = useState({ current: 0, total: 0, text: '' });  

  const [isDownloadingDocs, setIsDownloadingDocs] = useState(false);

  const userRole = String(localStorage.getItem('userRole') || localStorage.getItem('role') || '').toLowerCase().trim(); 

  const fetchSubmissions = async () => {
    setIsLoadingData(true);
    try {
      const token = localStorage.getItem('token');
      const pakPromise = fetch(`${BASE_URL}/api/admin/pak`, { headers: { 'Authorization': `Bearer ${token}` } });
      
      let usersPromise = Promise.resolve(null);
      if (userRole === 'admin' || userRole === 'satlak') {
          usersPromise = fetch(`${BASE_URL}/api/users`, { headers: { 'Authorization': `Bearer ${token}` } });
      }

      const [pakRes, usersRes] = await Promise.all([pakPromise, usersPromise]);

      if (!pakRes.ok) throw new Error("Gagal load PAK");
      let subsData = await pakRes.json();

      if (usersRes && usersRes.ok) {
         const usersData = await usersRes.json();
         if (usersData && usersData.length > 0) {
             const guruUsers = usersData.filter(u => String(u.role).toLowerCase().trim() === 'guru');
             guruUsers.forEach(guru => {
                const exists = subsData.find(s => String(s.nip) === String(guru.username));
                if (!exists) {
                   subsData.push({
                      pak_id: `empty-${guru.id}`,
                      user_id: guru.id,
                      nip: guru.username,
                      full_name: guru.full_name,
                      golongan: '-',
                      jenis_pak: '-',
                      kecamatan: guru.kecamatan || '-',
                      unit_kerja: 'Belum Diisi',
                      jabatan: '-',
                      status: 'Belum Usul',
                      status_ak: '-',
                      nomor_surat: '-',
                      tgl_cetak: null,
                      dokumen: [],
                      is_empty: true
                   });
                }
             });
         }
      }

      setSubmissions(subsData);
    } catch (err) { 
      console.error(err); 
      showToast("Gagal memuat data dari server.", "error");
    } finally {
      setIsLoadingData(false);
    }
  };
useEffect(() => {
  let interval;
  // PERBAIKAN: Gunakan selectedItem.pak_id bukan selectedItem.id
  if (selectedItem && selectedItem.pak_id && myLockToken) {
    interval = setInterval(async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/pak/${selectedItem.pak_id}/check-lock?lock_token=${myLockToken}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        const data = await res.json();
        
        if (data.is_kicked) {
          setKickedModal({ show: true, taken_by: data.taken_by });
          clearInterval(interval);
        }
      } catch (err) {
        console.error("Gagal mengecek status kunci berkas:", err);
      }
    }, 10000);
  }
  return () => clearInterval(interval);
}, [selectedItem, myLockToken]);
  useEffect(() => { 
    fetchSubmissions(); 
    const checkDeadline = async () => {
      if (userRole === 'satlak') {
        try {
          const token = localStorage.getItem('token');
          const res = await fetch(`${BASE_URL}/api/settings/deadline`, { headers: { 'Authorization': `Bearer ${token}` } });
          if (res.ok) {
            const data = await res.json();
            if (data.deadline) {
               const deadlineDate = new Date(data.deadline);
               deadlineDate.setHours(23, 59, 59, 999);
               setIsClosed(new Date() > deadlineDate);
            }
          }
        } 
        catch (err) { console.error(err) }
      }
    };
    checkDeadline();
  }, [userRole]);

  useEffect(() => {
    return () => {
        if (view === 'detail' && selectedItem?.pak_id) {
            try {
                const token = localStorage.getItem('token');
                fetch(`${BASE_URL}/api/admin/pak/${selectedItem.pak_id}/unlock`, {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json' 
                    },
                    body: JSON.stringify({ lock_token: myLockToken }),
                    keepalive: true 
                }).catch(() => {});
            } catch (e) {}
        }
    };
  }, [view, selectedItem, myLockToken, BASE_URL]);

  const handleFilterChange = (e, col) => {
      setFilters(prev => ({ ...prev, [col]: e.target.value }));
      setCurrentPage(1);
  };

 const filteredSubmissions = submissions.filter(sub => {
    const stringTglCetak = sub.tgl_cetak ? new Date(sub.tgl_cetak).toLocaleDateString('id-ID') : '-';
    const stringTglUsul = sub.tgl_input 
        ? new Date(sub.tgl_input).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }) 
        : '-';
    const stringTglValidasi = sub.tgl_verifikasi 
        ? new Date(sub.tgl_verifikasi).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' }) 
        : (sub.status === 'Pending' ? 'Menunggu' : '-');
    // Logika Filter Upload Dokumen
    const isBelumUpload = !sub.dokumen || sub.dokumen.length === 0;
    let matchUpload = true;
    if (filters.uploadStatus === 'belum') matchUpload = isBelumUpload;
    if (filters.uploadStatus === 'sudah') matchUpload = !isBelumUpload;

    // Logika Filter Status 
    let matchStatus = true;
    if (filters.status === 'berkas_masuk') matchStatus = !sub.is_empty;
    else if (filters.status) matchStatus = (sub.status || '').toLowerCase() === filters.status.toLowerCase();

    // Logika Filter Kecamatan (Normalized)
    const subKec = normalizeKecamatan(sub.kecamatan);
    let matchKecamatan = true;
    if (filters.kecamatan) {
        if (filters.kecamatan === 'Sudindik JT 2') {
             matchKecamatan = subKec === 'Sudindik JT 2';
        } else {
             matchKecamatan = subKec.toLowerCase().includes(filters.kecamatan.toLowerCase());
        }
    }

    // Logika Filter Jabatan (Normalized)
    let matchJabatan = true;
    if (filters.jabatan) {
        const subJab = normalizeJabatan(sub.jabatan);
        matchJabatan = subJab === filters.jabatan;
    }

    // Logika Cetak Status Virtual
    let matchCetakStatus = true;
    if (filters.cetakStatus === 'sudah') matchCetakStatus = sub.nomor_surat && sub.nomor_surat !== '-';
    if (filters.cetakStatus === 'belum') matchCetakStatus = !sub.nomor_surat || sub.nomor_surat === '-';
    
    let matchStatusAk = true;
    if (filters.statusAk) {
        matchStatusAk = (sub.status_ak || '').toLowerCase() === filters.statusAk.toLowerCase();
    }
    
    return matchUpload && matchStatus && matchKecamatan && matchJabatan && matchCetakStatus && matchStatusAk &&
    stringTglUsul.toLowerCase().includes(filters.tglUsul.toLowerCase()) &&          // BARIS BARU
           stringTglValidasi.toLowerCase().includes(filters.tglValidasi.toLowerCase()) &&  // BARIS BARU
           ((sub.full_name || '').toLowerCase().includes(filters.namaNip.toLowerCase()) || (sub.nip || '').includes(filters.namaNip)) &&
           (sub.golongan || '').toLowerCase().includes(filters.golongan.toLowerCase()) &&
           (sub.unit_kerja || '').toLowerCase().includes(filters.unitKerja.toLowerCase()) &&
           (sub.jenis_pak || 'Integrasi').toLowerCase().includes(filters.jenisPak.toLowerCase()) &&
           (sub.nomor_surat || '-').toLowerCase().includes(filters.nomorSurat.toLowerCase()) &&
           stringTglCetak.toLowerCase().includes(filters.tglCetak.toLowerCase());
  });
// Fungsi ketika judul kolom di-klik
  const requestSort = (key) => {
    let direction = 'desc'; // Default klik pertama kali ke desc (terbaru)
    if (sortConfig.key === key && sortConfig.direction === 'desc') {
      direction = 'asc'; // Jika di-klik lagi, ubah ke asc (terlama)
    }
    setSortConfig({ key, direction });
    setCurrentPage(1); // Reset ke halaman 1 tiap kali ganti sorting
  };

  // Terapkan sorting ke data yang sudah di-filter
  const sortedSubmissions = [...filteredSubmissions].sort((a, b) => {
    let aValue = 0;
    let bValue = 0;
    
    // Ambil nilai waktu dalam milidetik (getTime)
    if (sortConfig.key === 'tgl_usul') {
        aValue = new Date(a.tgl_input || a.updated_at || 0).getTime();
        bValue = new Date(b.tgl_input || b.updated_at || 0).getTime();
    } else if (sortConfig.key === 'tgl_validasi') {
        aValue = new Date(a.tgl_verifikasi || (['Disetujui', 'Ditolak'].includes(a.status) ? a.updated_at : 0)).getTime();
        bValue = new Date(b.tgl_verifikasi || (['Disetujui', 'Ditolak'].includes(b.status) ? b.updated_at : 0)).getTime();
    }

    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });
  const totalPages = Math.ceil(filteredSubmissions.length / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedSubmissions.slice(indexOfFirstItem, indexOfLastItem);

const calculateData = (item) => {
    if (item.is_empty) return null;
    const rawAkLama = String(item.ak_lama || '0').replace(',', '.');
    let akLama = Number(rawAkLama) || 0;

    const golInfo = GOLONGAN_MAP[item.golongan] || GOLONGAN_MAP['III/a'];
    const golonganPegawai = String(item.golongan || '').toLowerCase().replace(/\s/g, '');
    
    const isGol3A = golonganPegawai === 'iii/a' || golonganPegawai === 'iiia';
    const isBaseGol = ['iii/a', 'iii/c', 'iv/a', 'iv/d'].includes(golonganPegawai);
    let akPG = item.is_pencantuman_gelar === 'Ya' ? golInfo.akLama * 0.25 : 0;
    item.ak_pg = akPG;
    
    let skpData = typeof item.skp_data === 'string' ? JSON.parse(item.skp_data) : (item.skp_data || []);
    let validSkpList = skpData.filter(s => s && s.kode && s.kode !== '');

    // --- UBAH MENJADI ---
const isKonversi = (item.jenis_pak || 'Integrasi').toLowerCase() === 'konversi';
const labelJenisPak = isKonversi 
    ? (isGol3A ? 'Angka Kredit Dasar' : 'Angka Kredit Sebelumnya') 
    : 'Angka Kredit Integrasi';
    let tahunBaseAK = '-';
    let periodeCetak = '-';
    const parsedMulai = safeParseDate(item.masa_penilaian_mulai);
    const parsedSelesai = safeParseDate(item.masa_penilaian_selesai);
    const parsedTmt = safeParseDate(item.tmt_jabatan_baru);
    const parsedTmtAsli = safeParseDate(item.tmt_jabatan);
    const parsedTmtGol = safeParseDate(item.tmt_golongan); // <--- TAMBAHKAN BARIS INI
    const isJabatanTidakSesuai = item.is_jabatan_sesuai === 'Tidak';

    // --- HELPER PERBANDINGAN TANGGAL (Format: YYYYMMDD) ---
    const getComparableDateNum = (pDate) => {
        if (!pDate) return 0;
        return pDate.year * 10000 + pDate.month * 100 + pDate.day;
    };

    const selesaiNum = getComparableDateNum(parsedSelesai);
    const tmtAsliNum = getComparableDateNum(parsedTmtAsli);

   // --- 1. DETEKSI RESET AK AWAL (Sesuai Logika Mas Pepin) ---
    const isGolKhususNol = ['iii/c', 'iv/a', 'iv/d'].includes(golonganPegawai);
    let isResetNol = false;

    if (isKonversi && isGolKhususNol) {
        // [ATURAN BARU] Jika TMT Golongan lebih dari 2023 (2024 dst), langsung jadikan 0
        if (parsedTmtGol && parsedTmtGol.year > 2023) {
            isResetNol = true;
        }
        // Jika TMT Golongan 2023 ke bawah, gunakan aturan lama
        else if (parsedSelesai && parsedTmtAsli) {
            // Jika masa penilaian PAK sebelumnya SEBELUM TMT Jabfung -> Reset 0
            if (selesaiNum < tmtAsliNum) {
                isResetNol = true;
            } else {
                // Jika masa penilaian PAK sebelumnya SETELAH/SAMA DENGAN TMT Jabfung -> Lanjut
                isResetNol = false; 
            }
        } else if (item.is_baru_naik_jenjang === 'Ya') {
            isResetNol = true; // Fallback jika user centang manual
        } else if (!parsedSelesai && parsedTmtAsli) {
            isResetNol = true; // Belum pernah punya PAK (selesai kosong), otomatis reset
        }
    }

    // Eksekusi reset AK
    if (isResetNol) {
        akLama = 0;
    }

    let startMonthNum, startYear, startDay = 1;
    let endYear = 2025, endMonthNum = 12, endDay = 31;

    if (isKonversi) {
        // --- 2. TENTUKAN KAPAN PERIODE SKP DIMULAI ---
        let shouldStartFromTmt = false;
        let forceEnd2025 = false; 
        
        if (isGol3A) {
            forceEnd2025 = true; // 3A dipaksa sampai akhir 2025
        } 
        
        // Sesuai Logika Mas Pepin: Jika PAK terakhir SEBELUM TMT Jabfung (atau kosong) -> Mulai dari TMT
        if (parsedTmtAsli) {
            if (!parsedSelesai || selesaiNum < tmtAsliNum) {
                shouldStartFromTmt = true;
            }
        }

        // --- 3. SETTING TANGGAL MULAI ---
       if (shouldStartFromTmt && parsedTmtAsli) {
            // Gunakan tanggal eksak TMT untuk semua golongan
            startDay = parsedTmtAsli.day; 
            startMonthNum = parsedTmtAsli.month;
            startYear = parsedTmtAsli.year;
            tahunBaseAK = startYear;
            validSkpList = validSkpList.filter(s => parseInt(s.tahun) >= startYear);
        } else if (parsedSelesai) {
            // Jika SETELAH TMT Jabfung -> Mulai dari H+1 (Masa Akhir Penilaian + 1)
            startDay = 1;
            startMonthNum = parsedSelesai.month + 1;
            startYear = parsedSelesai.year;
            if (startMonthNum > 12) { 
                startMonthNum = 1;
                startYear += 1; 
            }
            tahunBaseAK = parsedSelesai.year;
            validSkpList = validSkpList.filter(s => parseInt(s.tahun) >= startYear);
        } else {
            // Default Fallback
            startDay = 1;
            startMonthNum = 1;
            startYear = 2023;
            tahunBaseAK = startYear;
        }

   // --- 4. SETTING TANGGAL SELESAI ---
    if (forceEnd2025) {
        endYear = 2025;
        endMonthNum = 12;
        endDay = 31;
    } else if (isJabatanTidakSesuai && parsedTmt) {
        if (parsedTmt.month === 12 && parsedTmt.day === 31) {
            endYear = parsedTmt.year;
            endMonthNum = 12;
            endDay = 31;
        } else {
            endYear = parsedTmt.year;
            endMonthNum = parsedTmt.month - 1; 
            if (endMonthNum <= 0) { 
                endMonthNum = 12;
                endYear -= 1; 
            }
            endDay = new Date(endYear, endMonthNum, 0).getDate();
        }
    } else {
        endYear = 2025;
        endMonthNum = 12;
        endDay = 31;
    }

    // ---> KODE SKP 2026 BARU (KONVERSI) <---
    // Pastikan kode tw_2026 yang lama DIHAPUS dan diganti dengan 5 baris ini:
    const skp2026 = validSkpList.find(s => parseInt(s.tahun) === 2026);
    if (item.is_skp_2026 === 'Ya' || skp2026) {
        endYear = 2026;
        endMonthNum = (skp2026 && skp2026.bulan) ? parseInt(skp2026.bulan, 10) : 12; // Ambil nilai 1-12 bulan dari dropdown
        endDay = new Date(2026, endMonthNum, 0).getDate();
    }
    } else {
        // ==========================================
        // LOGIKA INTEGRASI (TIDAK ADA RESET AK)
        // ==========================================
        if (parsedSelesai) {
            tahunBaseAK = parsedSelesai.year;
        } else {
            tahunBaseAK = 2025;
        }
        
        const is4896 = Math.abs(akLama - 48.96) < 0.01;
        if (isGol3A && parsedTmtAsli) {
            startDay = parsedTmtAsli.day;
            startMonthNum = parsedTmtAsli.month;
            startYear = parsedTmtAsli.year;
        } else if (is4896 && parsedTmtAsli) {
            startDay = parsedTmtAsli.day;
            startMonthNum = parsedTmtAsli.month;
            startYear = parsedTmtAsli.year;
        } else {
            startDay = 1;
            startMonthNum = 1;
            startYear = 2023; 
        }

        endDay = 31;
        endMonthNum = 12;
        endYear = 2025; 
        
        // ---> KODE SKP 2026 BARU (INTEGRASI) <---
        // Pastikan kode tw_2026 yang lama DIHAPUS dan diganti dengan 5 baris ini:
        const skp2026Int = validSkpList.find(s => parseInt(s.tahun) === 2026);
        if (item.is_skp_2026 === 'Ya' || skp2026Int) {
            endYear = 2026;
            endMonthNum = (skp2026Int && skp2026Int.bulan) ? parseInt(skp2026Int.bulan, 10) : 12; // Ambil nilai 1-12 bulan dari dropdown
            endDay = new Date(2026, endMonthNum, 0).getDate();
        }
        
        validSkpList = validSkpList.filter(s => parseInt(s.tahun) >= startYear);
    }
    // Susun String Periode Cetak
    const tglMulaiStr = startYear ? `${String(startDay).padStart(2,'0')}-${String(startMonthNum).padStart(2,'0')}-${startYear}` : '-';
    const tglSelesaiStr = `${String(endDay).padStart(2,'0')}-${String(endMonthNum).padStart(2,'0')}-${endYear}`;
    periodeCetak = `${tglMulaiStr} s.d ${tglSelesaiStr}`;

    let totalAKSKP = 0;
    const detailSKP = validSkpList.map(s => {
        const skpYear = parseInt(s.tahun);
        let bulan = 0;
        let mStart = 1; 
        let mEnd = 12;

        // --- TAMBAHAN KODE: Geser awal perhitungan tabel jika TMT BUKAN tanggal 1 ---
        let hitungMulaiBulan = startMonthNum;
        
        // Jika TMT lebih dari tanggal 1 (misal tgl 2, 25, dst), hitungan SKP mulai bulan depannya
        if (startDay > 1) {
            hitungMulaiBulan += 1;
        }
        // -------------------------------------------------------------------------

        if (skpYear < startYear || skpYear > endYear) {
            bulan = 0; mStart = 0; mEnd = 0;
        } else if (startYear === endYear && skpYear === startYear) {
            bulan = endMonthNum - hitungMulaiBulan + 1;  // Ubah startMonthNum jadi hitungMulaiBulan
            mStart = hitungMulaiBulan; mEnd = endMonthNum; // Ubah startMonthNum jadi hitungMulaiBulan
        } else if (skpYear === startYear) {
            bulan = 12 - hitungMulaiBulan + 1;             // Ubah startMonthNum jadi hitungMulaiBulan
            mStart = hitungMulaiBulan; mEnd = 12;          // sUbah startMonthNum ssjadi sshitungMulaiBulan
        } else if (skpYear === endYear) {
            bulan = endMonthNum;
            mStart = 1; mEnd = endMonthNum;
        } else {
            bulan = 12;
            mStart = 1; mEnd = 12;
        }

        // Handle edge case jika perhitungan bulan menjadi minus/nol (misal TMT di akhir Desember)
        if (bulan <= 0) {
            bulan = 0;
            mStart = 0;
            mEnd = 0;
        }
        
        let predikat = '-'; let multiplier = 0;
        if (String(s.kode) === '1') { predikat = 'Amat Baik'; multiplier = 1.50; }
        else if (String(s.kode) === '2') { predikat = 'Baik'; multiplier = 1.00; }
        else if (String(s.kode) === '3') { predikat = 'Cukup'; multiplier = 0.75; }

        const akDidapat = (bulan / 12) * multiplier * golInfo.koef;
        totalAKSKP += akDidapat;

        let periodeStr = bulan > 0 ? `${monthNames[mStart]} - ${monthNames[mEnd]}` : '-';
        return { 
            ...s, 
            predikat, 
            bulan, 
            multiplier, 
            koef: golInfo.koef || 0, 
            periode: periodeStr,
            result: akDidapat,
            prosentaseStr: bulan === 12 ? `${multiplier * 100}%` : `(${bulan}/12) x ${multiplier * 100}%`,
            sudah_pak: s.sudah_pak 
        };
    }).filter(s => s.bulan > 0);

    const sisaAKLama = akLama; 
    const jumlahAkDiperoleh = sisaAKLama + totalAKSKP + akPG; 
    const akKonversiLama = isBaseGol ? 0 : golInfo.akLama;
    const totalKumulatif = jumlahAkDiperoleh; 
    const akKonversiBaru = totalKumulatif - akPG - akKonversiLama;
    const totalKonversi = akKonversiLama + akKonversiBaru; 
    
    const sisaPangkat = (akKonversiBaru + akPG) - golInfo.akLama; 
    const sisaJenjang = totalKumulatif - golInfo.jenjang;
    let autoStatusAk = 'Cukup';
    const isNaikJenjang = ['iii/b', 'iii/d', 'iv/c'].includes(golonganPegawai);
    
    if (sisaPangkat < 0) {
        autoStatusAk = 'Tidak Cukup';
    }
    if (isNaikJenjang && golInfo.jenjang !== -1 && sisaJenjang < 0) {
        autoStatusAk = 'Tidak Cukup';
    }

    return { 
      detailSKP, totalAKSKP, golInfo, sisaAKLama, jumlahAkDiperoleh, 
      akKonversiLama, akKonversiBaru, akPG, totalKonversi, totalKumulatif, sisaPangkat, sisaJenjang, 
      labelJenisPak, tahunBaseAK, periodeCetak, isKonversi,
      statusAk: item.status_ak || autoStatusAk,
      calcAutoStatusAk: autoStatusAk
    };
  };

 const handleSelect = async (item, forceTakeover = false) => {
    if (item.is_empty) return showToast("Pegawai ini belum menginput Biodata & SKP", "error");

    try {
        const token = localStorage.getItem('token');
        const lockRes = await fetch(`${BASE_URL}/api/admin/pak/${item.pak_id}/lock`, {
            method: 'POST',
            headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' 
            },
            // Langsung gunakan myLockToken bawaan Anda di sini!
            body: JSON.stringify({ lock_token: myLockToken, force_takeover: forceTakeover }) 
        });

        if (!lockRes.ok) {
            const errorData = await lockRes.json().catch(() => ({}));
            setLockWarning({ 
                show: true, 
                lockedBy: errorData.locked_by_name || errorData.message || 'Akun Lainnya',
                pendingItem: item 
            });
            return; 
        }
    } catch (err) {
        console.error("Gagal mengunci berkas:", err);
        showToast("Sistem gagal memverifikasi status kunci.", "error");
        return; 
    }

    // Jika force takeover berhasil, sembunyikan popup warningnya
    if (forceTakeover) {
        setLockWarning({ show: false, lockedBy: '', pendingItem: null });
        showToast("Berhasil mengambil alih paksa berkas!", "success");
    }

    // --- Sisa kode format data Anda ---
    const calc = calculateData(item);
    setCalculation(calc);
    const parsedSkpData = typeof item.skp_data === 'string' ? JSON.parse(item.skp_data) : (item.skp_data || []);
    const detailedItem = { ...item, skp_data: parsedSkpData, ak_lama: Number(String(item.ak_lama||'0').replace(',','.')), ak_pg: Number(String(item.ak_pg||'0').replace(',','.')), tahun_gelar_baru: item.tahun_gelar_baru || '-', dokumen: item.dokumen || [] };
    
    if (!detailedItem.jenis_jabatan) {
        let isGuru = true;
        if (detailedItem.jabatan && !detailedItem.jabatan.toLowerCase().includes('guru')) {
            isGuru = false;
        }
        detailedItem.jenis_jabatan = isGuru ? 'Guru' : 'Non-Guru';
    }

    setSelectedItem(detailedItem);
    setEditedBio(detailedItem);
    setView('detail');
  };

  const handleBackToList = () => {
    if (selectedItem && selectedItem.pak_id) {
       try {
           const token = localStorage.getItem('token');
           fetch(`${BASE_URL}/api/admin/pak/${selectedItem.pak_id}/unlock`, {
               method: 'POST',
               headers: { 
                   'Authorization': `Bearer ${token}`,
                   'Content-Type': 'application/json' 
               },
               body: JSON.stringify({ lock_token: myLockToken })
           }).catch(() => {});
       } catch(e) {}
    }
    setView('list');
    setSelectedItem(null);
    setEditedBio({});
    setPreviewUrl(null);
  };

  const handleBioChange = (e) => {
    const { name, value } = e.target;
    let updatedBio = { ...editedBio, [name]: value };
    if (['is_pencantuman_gelar', 'golongan'].includes(name)) {
        if (updatedBio.is_pencantuman_gelar === 'Ya') {
            const gInfo = GOLONGAN_MAP[updatedBio.golongan] || GOLONGAN_MAP['III/a'];
            updatedBio.ak_pg = gInfo.akLama * 0.25; 
        } else {
            updatedBio.ak_pg = 0;
        }
    }
    setEditedBio(updatedBio);
  };

  const handleSKPChange = (index, field, value) => {
    const newSkpData = [...(editedBio.skp_data || [])];
    if (!newSkpData[index]) newSkpData[index] = { tahun: '', kode: '' };
    newSkpData[index] = { ...newSkpData[index], [field]: value };
    setEditedBio({ ...editedBio, skp_data: newSkpData });
  };

  const executeSaveBio = async () => {
    setConfirmModal({ ...confirmModal, show: false });
    try {
      // 1. Hitung ulang status AK secara real-time sebelum dikirim
      const calc = calculateData(editedBio);
      
      // 2. Sisipkan status_ak terbaru ke dalam payload
      const payload = { ...editedBio, status_ak: calc.calcAutoStatusAk }; 
      delete payload.jenis_jabatan; 

      const token = localStorage.getItem('token');
      const res = await fetch(`${BASE_URL}/api/admin/users/${selectedItem.user_id}/profile`, {
        method: 'PUT', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error("Gagal update biodata");
      
      // 3. Perbarui state agar tabel dan UI langsung menggunakan status baru
      setSelectedItem({ ...editedBio, status_ak: calc.calcAutoStatusAk }); 
      setIsEditingBio(false); 
      showToast("Biodata berhasil diperbarui!", "success");
      
      setSubmissions(prev => prev.map(sub => sub.pak_id === editedBio.pak_id ? { ...editedBio, status_ak: calc.calcAutoStatusAk } : sub));
      
      setCalculation(calc);
    } catch (err) { showToast("Terjadi kesalahan saat menyimpan biodata.", "error"); }
  };

  const saveBioChanges = () => setConfirmModal({ show: true, title: "Simpan Perubahan", message: "Yakin ingin menyimpan perubahan biodata pegawai ini?", actionBtn: "Simpan Data", onConfirm: executeSaveBio });

  const submitRejection = async () => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`${BASE_URL}/api/admin/pak/${selectedItem.pak_id}/reject`, { 
        method: 'POST', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ reason: rejectReason }) 
      });
      setShowRejectModal(false); setRejectReason(''); 
      handleBackToList(); 
      fetchSubmissions(); 
      showToast("Berkas berhasil ditolak.", "success");
    } catch (err) { showToast("Gagal menolak berkas.", "error"); }
  };

  const executeApprove = async () => {
    setShowApproveModal(false);
    try {
      const token = localStorage.getItem('token');
      await fetch(`${BASE_URL}/api/admin/pak/${selectedItem.pak_id}/approve`, { 
        method: 'POST', 
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status_ak: calculation.calcAutoStatusAk }) 
      });
      handleBackToList(); 
      fetchSubmissions(); 
      showToast("Berkas berhasil disetujui.", "success");
    } catch (err) { showToast("Gagal menyetujui berkas.", "error"); }
  };

  const toggleRowSelection = (pakId) => setSelectedRows(prev => prev.includes(pakId) ? prev.filter(id => id !== pakId) : [...prev, pakId]);

  const toggleSelectAll = () => {
      const validCurrentItems = currentItems.filter(sub => !sub.is_empty).map(sub => sub.pak_id);
      if (validCurrentItems.length === 0) return;
      
      const isAllSelected = validCurrentItems.every(id => selectedRows.includes(id));
      if (isAllSelected) {
          setSelectedRows(prev => prev.filter(id => !validCurrentItems.includes(id)));
      } else {
          const newSelection = new Set([...selectedRows, ...validCurrentItems]);
          setSelectedRows(Array.from(newSelection));
      }
  };

const handleDownloadSemuaDokumen = async () => {
    if (!selectedItem || !selectedItem.dokumen || selectedItem.dokumen.length === 0) return;
    
    setIsDownloadingDocs(true);
    showToast("Mempersiapkan file ZIP. Mohon tunggu, proses ini butuh waktu...", "success");

    try {
      const zip = new JSZip();
      const docs = selectedItem.dokumen;
      let hasError = false;
      const token = localStorage.getItem('token'); // Ambil token untuk akses backend

      for (let i = 0; i < docs.length; i++) {
        let downloadUrl = docs[i].url;
        
        // Memformat URL Google Drive untuk direct download
        if (downloadUrl.includes('drive.google.com/file/d/')) {
            const match = downloadUrl.match(/\/d\/(.+?)\//);
            if (match && match[1]) downloadUrl = `https://drive.google.com/uc?export=download&id=${match[1]}`;
        } else if (downloadUrl.includes('drive.google.com/open?id=')) {
            const urlParams = new URLSearchParams(downloadUrl.substring(downloadUrl.indexOf('?')));
            const fileId = urlParams.get('id');
            if (fileId) downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
        }

        try {
            // MINTA TOLONG KE BACKEND UNTUK DOWNLOAD (PROXY)
            const response = await fetch(`${BASE_URL}/api/proxy-download`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' 
                },
                body: JSON.stringify({ url: downloadUrl })
            });

            if (!response.ok) throw new Error("Gagal mengambil file melalui proxy");
            
            const blob = await response.blob();
            // Tentukan nama file
            const fileName = docs[i].nama ? `${docs[i].nama}.pdf` : `Dokumen_Lampiran_${i+1}.pdf`;
            
            // Masukkan ke dalam objek ZIP
            zip.file(fileName, blob);
        } catch (fetchErr) {
            console.error(`Gagal mengunduh dokumen ${docs[i].nama}:`, fetchErr);
            hasError = true; // Tandai jika ada satu/lebih file yang gagal
        }
      }

      // Generate file ZIP
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const safeName = (selectedItem.full_name || 'Pegawai').replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, '_');
      
      saveAs(zipBlob, `Berkas_PAK_${safeName}_${selectedItem.nip}.zip`);
      
      if (hasError) {
          showToast("ZIP dibuat, tetapi ada file yang gagal diunduh. Cek console untuk detail.", "error");
      } else {
          showToast("File ZIP berhasil diunduh!", "success");
      }
      
    } catch (err) {
      console.error("Gagal membuat ZIP:", err);
      showToast("Terjadi kesalahan sistem saat membuat ZIP.", "error");
    } finally {
      setIsDownloadingDocs(false);
    }
  };

const handleStartBatchProcess = () => {
    const itemsToPrint = submissions.filter(
      s => selectedRows.includes(s.pak_id) && !s.is_empty
    );

    if (itemsToPrint.length === 0) {
      showToast("Tidak ada dokumen yang dipilih untuk disiapkan.", "error");
      return;
    }

    setShowBatchModal(false);
    let currentSeq = Number(batchStartNum);

    const calculatedQueue = itemsToPrint.map((item) => {
      const calc = calculateData(item);

      // =========================
      // NOMOR SURAT
      // =========================
      let generatedNomor = "";

      const sudahPunyaNomor =
        item.nomor_surat &&
        item.nomor_surat.trim() !== "" &&
        item.nomor_surat !== "-" &&
        item.nomor_surat !== "...../KG.04.04";

      if (useExistingNumber && sudahPunyaNomor) {
        generatedNomor = item.nomor_surat;
      } else {
        generatedNomor = `${currentSeq}/KG.04.04`;
        currentSeq++;
      }

      // =========================
      // TANGGAL CETAK / TTD
      // =========================
      const tanggalLama = normalizePrintDate(item.tgl_cetak);

      const generatedTanggalTtd =
        useExistingPrintDate && tanggalLama
          ? tanggalLama
          : tanggalTtd;

      const cleanItem = {
        ...item,
        ak_lama: Number(String(item.ak_lama || '0').replace(',', '.')),
        ak_pg: Number(String(item.ak_pg || '0').replace(',', '.'))
      };

      return {
        item: cleanItem,
        calculation: calc,
        generatedNomor,
        generatedTanggalTtd
      };
    });

    setPrintQueue(calculatedQueue);
  };

  const executePDFGeneration = async () => {
    setIsProcessingZip(true);

    const successfulPrints = [];
    const failedPrints = [];

    /*
     * FAST MODE UNTUK RATUSAN PAK
     * ---------------------------
     * - Browser hanya render 1 PAK ke DOM pada satu waktu.
     * - Maksimal 20 PDF / ZIP supaya tidak menghasilkan 28 ZIP
     *   ketika mencetak 277 PAK.
     * - html2canvas scale 1.5 + JPEG 0.80:
     *   jauh lebih ringan daripada PNG/scale 2.5.
     * - Status DB disimpan setiap ZIP selesai, bukan menunggu seluruh
     *   277 dokumen selesai.
     */
    const ZIP_DOC_LIMIT = 20;
    const RENDER_SCALE = 1.5;
    const JPEG_QUALITY = 0.80;

    const totalParts = Math.max(
      1,
      Math.ceil(printQueue.length / ZIP_DOC_LIMIT)
    );

    let zip = new JSZip();
    let currentPart = 1;
    let currentZipCount = 0;
    let currentZipPrints = [];

    const token = localStorage.getItem('token');

    const sleep = (ms) =>
      new Promise(resolve => setTimeout(resolve, ms));

    const waitTwoFrames = () =>
      new Promise(resolve => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve);
        });
      });

    const makeTimestamp = () => {
      const now = new Date();

      return [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
        '-',
        String(now.getHours()).padStart(2, '0'),
        String(now.getMinutes()).padStart(2, '0')
      ].join('');
    };

    const waitForActivePreview = async () => {
      // Tunggu React selesai mengganti activePrintItem.
      await waitTwoFrames();

      let root = null;

      for (let attempt = 0; attempt < 30; attempt++) {
        root = document.querySelector('.teacher-doc-fast');

        if (
          root &&
          root.querySelectorAll('.pdf-page').length > 0
        ) {
          break;
        }

        await sleep(20);
      }

      if (!root) {
        throw new Error(
          'Preview PDF aktif gagal dirender.'
        );
      }

      // Pastikan asset gambar seperti logo DKI/TTE/BSrE sudah siap.
      const images = Array.from(root.querySelectorAll('img'));

      await Promise.all(
        images.map(img => {
          if (img.complete && img.naturalWidth > 0) {
            return Promise.resolve();
          }

          return new Promise(resolve => {
            const done = () => resolve();

            img.addEventListener('load', done, {
              once: true
            });

            img.addEventListener('error', done, {
              once: true
            });

            // Jangan menggantung proses selamanya jika asset gagal.
            setTimeout(done, 1500);
          });
        })
      );

      // Sedikit jeda agar layout final stabil.
      await sleep(15);

      return root;
    };

    const updatePrintStatus = async (printData) => {
      if (!printData.length) return;

      const response = await fetch(
        `${BASE_URL}/api/admin/pak/update-print-status`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            printData
          })
        }
      );

      if (!response.ok) {
        let message =
          'PDF berhasil dibuat tetapi status cetak gagal diperbarui.';

        try {
          const data = await response.json();
          message = data.msg || message;
        } catch {}

        throw new Error(message);
      }
    };

    const saveCurrentZip = async () => {
      if (currentZipCount === 0) return;

      setProgressStatus(prev => ({
        ...prev,
        text:
          totalParts > 1
            ? `Membungkus ZIP ${currentPart}/${totalParts}...`
            : 'Membungkus file ZIP...'
      }));

      /*
       * JPEG sudah terkompresi, jadi level DEFLATE tinggi hanya menambah CPU
       * tanpa pengurangan ukuran yang berarti.
       */
      const zipBlob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 3
        }
      });

      const stamp = makeTimestamp();

      const zipName =
        totalParts > 1
          ? `PAK_SIAP_TTE_BESIGN_${stamp}_PART_${String(currentPart).padStart(2, '0')}-OF-${String(totalParts).padStart(2, '0')}.zip`
          : `PAK_SIAP_TTE_BESIGN_${stamp}.zip`;

      saveAs(zipBlob, zipName);

      /*
       * Simpan nomor + tanggal setelah ZIP bagian ini berhasil dibuat.
       * Untuk 277 PAK, data bagian awal tidak hilang jika proses terputus
       * di bagian akhir.
       */
      await updatePrintStatus(currentZipPrints);

      // Beri browser waktu menginisiasi download dan melepas object.
      await sleep(250);

      zip = new JSZip();
      currentZipCount = 0;
      currentZipPrints = [];
      currentPart += 1;
    };

    try {
      for (let i = 0; i < printQueue.length; i++) {
        const q = printQueue[i];

        const teacherName = (
          q.item.full_name || 'TanpaNama'
        )
          .replace(/[^a-zA-Z0-9 ]/g, '')
          .trim();

        const safeTeacherName =
          teacherName.replace(/\s+/g, '_');

        const fileName =
          `${safeTeacherName}_${q.item.nip}.pdf`;

        try {
          setProgressStatus({
            current: i + 1,
            total: printQueue.length,
            text:
              `Menyiapkan ${teacherName} • ` +
              `ZIP ${Math.floor(i / ZIP_DOC_LIMIT) + 1}/${totalParts}`
          });

          /*
           * HANYA ITEM INI yang dirender.
           * Item sebelumnya otomatis diganti React.
           */
          setActivePrintItem(q);

          const previewRoot =
            await waitForActivePreview();

          const pages =
            previewRoot.querySelectorAll('.pdf-page');

          if (!pages.length) {
            throw new Error(
              'Halaman PDF tidak ditemukan pada preview cetak.'
            );
          }

          const doc = new jsPDF({
            orientation: 'p',
            unit: 'mm',
            format: 'a4',
            compress: true
          });

          const pdfWidth =
            doc.internal.pageSize.getWidth();

          const pdfHeight =
            doc.internal.pageSize.getHeight();

          for (let j = 0; j < pages.length; j++) {
            const pageElement = pages[j];

            const canvas = await html2canvas(
              pageElement,
              {
                scale: RENDER_SCALE,
                useCORS: true,
                logging: false,
                scrollY: 0,
                scrollX: 0,
                backgroundColor: '#ffffff',
                imageTimeout: 8000,
                removeContainer: true
              }
            );

            if (j > 0) {
              doc.addPage('a4', 'p');
            }

            const imgData =
              canvas.toDataURL(
                'image/jpeg',
                JPEG_QUALITY
              );

            doc.addImage(
              imgData,
              'JPEG',
              0,
              0,
              pdfWidth,
              pdfHeight,
              undefined,
              'FAST'
            );

            /*
             * Penting untuk proses ratusan halaman:
             * perkecil canvas setelah masuk PDF agar bitmap besar dapat
             * lebih cepat dilepas garbage collector.
             */
            canvas.width = 1;
            canvas.height = 1;
          }

          const pdfBlob = doc.output('blob');

          zip.file(
            fileName,
            pdfBlob,
            {
              binary: true
            }
          );

          currentZipCount += 1;

          const printStatus = {
            pak_id: q.item.pak_id,
            nomor_surat: q.generatedNomor,
            tgl_cetak: q.generatedTanggalTtd
          };

          currentZipPrints.push(printStatus);
          successfulPrints.push(printStatus);

          /*
           * Tidak perlu mempertahankan preview item setelah PDF selesai.
           */
          setActivePrintItem(null);

          // Keluarkan ZIP per 20 PDF.
          if (
            currentZipCount >= ZIP_DOC_LIMIT
          ) {
            await saveCurrentZip();
          }

          /*
           * Beri event loop sedikit napas setiap beberapa dokumen.
           * Mengurangi risiko tab dianggap tidak responsif.
           */
          if ((i + 1) % 5 === 0) {
            await sleep(40);
          }
        } catch (fileError) {
          console.error(
            `Gagal menyiapkan PDF ${teacherName}:`,
            fileError
          );

          setActivePrintItem(null);

          failedPrints.push({
            name: teacherName,
            error:
              fileError.message ||
              'Gagal membuat PDF'
          });
        }
      }

      // Simpan sisa terakhir (< 20 PDF).
      await saveCurrentZip();

      setActivePrintItem(null);

      if (successfulPrints.length === 0) {
        const firstError =
          failedPrints[0]?.error ||
          'Semua dokumen gagal dibuat.';

        throw new Error(firstError);
      }

      /*
       * Refresh sekali setelah semua bagian selesai.
       * DB sebenarnya sudah disimpan per ZIP.
       */
      fetchSubmissions();

      if (totalParts > 1) {
        showToast(
          `${successfulPrints.length} dokumen berhasil dibuat dalam ${totalParts} ZIP.` +
          (failedPrints.length
            ? ` ${failedPrints.length} dokumen gagal.`
            : ' Jika browser meminta izin multiple downloads, pilih Izinkan.'),
          failedPrints.length
            ? 'error'
            : 'success'
        );
      } else if (failedPrints.length > 0) {
        showToast(
          `${successfulPrints.length} dokumen berhasil, ` +
          `${failedPrints.length} dokumen gagal.`,
          'error'
        );
      } else {
        showToast(
          `${successfulPrints.length} dokumen siap diproses di BeSign Desktop.`,
          'success'
        );
      }
    } catch (error) {
      console.error(error);

      showToast(
        error.message ||
        'Terjadi kesalahan saat menyiapkan dokumen TTE.',
        'error'
      );
    } finally {
      setActivePrintItem(null);
      setIsProcessingZip(false);
      setPrintQueue([]);
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    if (printQueue.length > 0 && !isProcessingZip) {
      executePDFGeneration();
    }
  }, [printQueue]);

const exportToExcel = () => {
      // LOGIKA BARU: Gunakan selectedRows jika ada yang dicentang
      const sourceData = selectedRows.length > 0 
          ? submissions.filter(item => selectedRows.includes(item.pak_id) && !item.is_empty)
          : filteredSubmissions.filter(item => !item.is_empty);

      if (sourceData.length === 0) {
          showToast("Tidak ada data untuk diexport", "error");
          return;
      }

      const dataToExport = sourceData.map((item, index) => {
          const calc = calculateData(item) || {};
          
          let skpData = [];
          try { skpData = typeof item.skp_data === 'string' ? JSON.parse(item.skp_data) : (item.skp_data || []); } catch(e) {}
          const skp1 = skpData[0] || {};
          const skp2 = skpData[1] || {};
          const skp3 = skpData[2] || {};
          const skp4 = skpData[3] || {};
          const docs = item.dokumen || [];
          const docLinks = docs.map(d => `${d.nama}: ${d.url}`).join('\r\n');

          const jenisPak = (item.jenis_pak || 'Integrasi').toLowerCase();
          const akLama = item.ak_lama ? Number(String(item.ak_lama).replace(',','.')) : 0;
          
          const parsedSelesai = safeParseDate(item.masa_penilaian_selesai);
          const tahunSelesai = parsedSelesai ? parsedSelesai.year : (jenisPak === 'integrasi' ? 2022 : 2023);

          const akPakIntegrasi = jenisPak === 'integrasi' ? akLama : '';

          const getAkTahunan = (tahun) => {
              let nilai = 0;
              if (jenisPak === 'konversi' && tahunSelesai === tahun) {
                  nilai += akLama;
              }
              const skp = (calc.detailSKP || []).find(s => parseInt(s.tahun) === tahun);
              if (skp && skp.result) {
                  nilai += Number(skp.result);
              }
              return nilai > 0 ? Number(nilai.toFixed(3)) : '';
          };

          return {
              "No": index + 1,
              "NIP": item.nip,
              "Nama Lengkap": item.full_name,
              "Wil.": item.kecamatan || '-',
              "Tempat Lahir": item.tempat_lahir || '-',
              "Tanggal Lahir": item.tanggal_lahir ? new Date(item.tanggal_lahir).toLocaleDateString('id-ID') : '-',
              "Jenis Kelamin": item.jenis_kelamin || '-',
              "Golongan": item.golongan || '-',
              "Pangkat": item.pangkat || '-',
              "TMT Golongan": item.tmt_golongan ? new Date(item.tmt_golongan).toLocaleDateString('id-ID') : '-',
              "Masa Kerja": `${item.masa_kerja_tahun || 0} Tahun ${item.masa_kerja_bulan || 0} Bulan`,
              "Pendidikan Terakhir": item.pendidikan_pangkat || '-',
              "Pendidikan Gelar Baru": item.pendidikan_gelar_baru || '-',
              "Nama Jurusan/Prodi": item.nama_pendidikan_baru || '-',
              "Tahun Lulus": item.tahun_gelar_baru || '-',
              "Tahun Usulan Gelar": item.tahun_usulan_gelar || '-',
              "Jenis Jabatan": item.jenis_jabatan || '-',
              "Jabatan Fungsional": item.jabatan || '-',
              "TMT Jabatan": item.tmt_jabatan ? new Date(item.tmt_jabatan).toLocaleDateString('id-ID') : '-',
              "Jabatan Sudah Sesuai?": item.is_jabatan_sesuai || 'Ya',
              "Jabatan Baru": item.jabatan_baru || '-',
              "TMT Jabatan Baru": item.tmt_jabatan_baru ? new Date(item.tmt_jabatan_baru).toLocaleDateString('id-ID') : '-',
              "Unit Kerja": item.unit_kerja || '-',
              "Jenis PAK Terakhir": item.jenis_pak || 'Integrasi',
              "Mulai Penilaian PAK": item.masa_penilaian_mulai ? new Date(item.masa_penilaian_mulai).toLocaleDateString('id-ID') : '-',
              "Selesai Penilaian PAK": item.masa_penilaian_selesai ? new Date(item.masa_penilaian_selesai).toLocaleDateString('id-ID') : '-',
              "Baru Naik Jenjang (Reset 0)?": item.is_baru_naik_jenjang || 'Tidak',
              "Nilai AK Terakhir": akLama,

              // --- KOLOM FORMAT BARU SESUAI GAMBAR ---
              "AK pada PAK Integrasi": akPakIntegrasi,
              "AK Konversi 2023": getAkTahunan(2023),
              "AK Konversi 2024": getAkTahunan(2024),
              "AK Konversi 2025": getAkTahunan(2025),
              "AK Konversi 2026": getAkTahunan(2026),
              "Pencantuman Gelar": calc.akPG ? Number(calc.akPG).toFixed(3) : '',
              "Total AK": calc.totalKumulatif ? Number(calc.totalKumulatif).toFixed(3) : 0,

              "Total AK SKP Didapat": calc.totalAKSKP ? Number(calc.totalAKSKP).toFixed(3) : 0,
              "AK Konversi Baru": calc.akKonversiBaru ? Number(calc.akKonversiBaru).toFixed(3) : 0,
              "Sisa AK untuk Pangkat": calc.sisaPangkat ? Number(calc.sisaPangkat).toFixed(3) : 0,
              "Sisa AK untuk Jenjang": calc.sisaJenjang ? Number(calc.sisaJenjang).toFixed(3) : 0,
              "Status Kelayakan AK": item.status_ak || calc.calcAutoStatusAk || '-',
              "SKP Tahun 1": skp1.tahun || '-',
              "Nilai SKP Tahun 1": skp1.kode === '1' ? 'Amat Baik' : skp1.kode === '2' ? 'Baik' : skp1.kode === '3' ? 'Cukup' : '-',
              "SKP Tahun 2": skp2.tahun || '-',
              "Nilai SKP Tahun 2": skp2.kode === '1' ? 'Amat Baik' : skp2.kode === '2' ? 'Baik' : skp2.kode === '3' ? 'Cukup' : '-',
              "SKP Tahun 3": skp3.tahun || '-',
              "Nilai SKP Tahun 3": skp3.kode === '1' ? 'Amat Baik' : skp3.kode === '2' ? 'Baik' : skp3.kode === '3' ? 'Cukup' : '-',
              "SKP Tahun 4 (2026)": skp4.tahun || '-',
              "Nilai SKP Tahun 4": skp4.kode === '1' ? 'Amat Baik' : skp4.kode === '2' ? 'Baik' : skp4.kode === '3' ? 'Cukup' : '-',
              "Status Usulan Terakhir": item.status || 'Pending',
              "Catatan Penolakan": item.catatan_penolakan || '-',
              "Nomor Surat (Cetak)": item.nomor_surat || '-',
              "Tanggal Cetak": item.tgl_cetak ? new Date(item.tgl_cetak).toLocaleDateString('id-ID') : '-',
              "Link Dokumen Lampiran": docLinks
          };
      });

      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data_Verifikasi");
      XLSX.writeFile(workbook, `Rekap_PAK_${new Date().getTime()}.xlsx`);
  };
  const kecamatanList = [...new Set(submissions.map(s => normalizeKecamatan(s.kecamatan)))].sort();

  const totalDisetujui = submissions.filter(s => s.status?.toLowerCase() === 'disetujui').length;
  const belumUploadList = submissions.filter(s => {
     const hasNoDocs = !s.dokumen || s.dokumen.length === 0;
     const jabStr = String(s.jabatan || '').toLowerCase();
     const isGuru = s.is_empty || jabStr === '' || jabStr === '-' || jabStr.includes('guru') || (!jabStr.includes('pengawas') && !jabStr.includes('penilik') && !jabStr.includes('pamo'));
     return hasNoDocs && isGuru;
  });

  const rekapKecamatan = {};
  const rekapJabatan = {};
  
  belumUploadList.forEach(sub => {
     const kec = normalizeKecamatan(sub.kecamatan);
     rekapKecamatan[kec] = (rekapKecamatan[kec] || 0) + 1;
     
     const jab = normalizeJabatan(sub.jabatan);
     rekapJabatan[jab] = (rekapJabatan[jab] || 0) + 1;
  });

  const stats = {
      total: submissions.filter(s => !s.is_empty).length,
      pending: submissions.filter(s => s.status?.toLowerCase() === 'pending').length,
      disetujui: totalDisetujui,
      ditolak: submissions.filter(s => s.status?.toLowerCase() === 'ditolak').length,
      akCukup: submissions.filter(s => s.status_ak === 'Cukup').length,
      akTidakCukup: submissions.filter(s => s.status_ak === 'Tidak Cukup').length,
      belumUpload: belumUploadList.length,
      sudahDicetak: submissions.filter(s => s.status?.toLowerCase() === 'disetujui' && s.nomor_surat && s.nomor_surat !== '-').length,
      belumDicetak: submissions.filter(s => s.status?.toLowerCase() === 'disetujui' && (!s.nomor_surat || s.nomor_surat === '-')).length
  };

  const applyDashboardFilter = (field, value) => {
      setFilters(prev => {
          const base = {
              ...prev,
              status: '',
              statusAk: '',
              uploadStatus: '',
              cetakStatus: '',
              jabatan: ''
          };
          
          if (field === 'uploadStatus') base.kecamatan = ''; 
          
          base[field] = value;
          
          if (field === 'statusAk') base.status = 'berkas_masuk';
          if (field === 'cetakStatus') base.status = 'disetujui';
          
          return base;
      });
      setCurrentPage(1);
  };

  const handleRekapClick = (type, value) => {
      setShowRekapModal(false);
      setFilters(prev => ({ 
          ...prev, 
          status: '', statusAk: '', cetakStatus: '', jabatan: '', kecamatan: '', 
          uploadStatus: 'belum',
          [type]: value 
      }));
      setCurrentPage(1);
  };

  return (
    <>
      {previewUrl && (
        <div className="fixed right-0 top-0 bottom-0 w-[50%] bg-white shadow-[-15px_0_35px_rgba(0,0,0,0.1)] z-[9999] flex flex-col border-l border-slate-300 pointer-events-auto">
          <div className="flex justify-between items-center p-4 border-b bg-slate-100">
            <h3 className="font-bold text-slate-800 flex items-center gap-2"><FileText size={18}/> Preview Eviden</h3>
            <button onClick={() => setPreviewUrl(null)} className="p-2 hover:bg-rose-500 hover:text-white rounded-full transition-all text-slate-500"><X size={20} /></button>
          </div>
          <div className="flex-1 w-full bg-slate-200">
            <iframe src={previewUrl.includes('drive.google.com') ? previewUrl.replace(/\/view.*/, '/preview') : previewUrl} className="w-full h-full border-none" title="Preview"></iframe>
          </div>
        </div>
      )}

     {/* 1. MODAL WARNING TERKUNCI & TOMBOL AMBIL ALIH */}
      {lockWarning.show && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-sm flex flex-col items-center text-center animate-fade-in-up">
            <div className="w-20 h-20 bg-rose-50 text-rose-500 rounded-full flex items-center justify-center mb-5 shadow-inner border border-rose-100">
              <Lock size={36} strokeWidth={2.5} />
            </div>
            <h3 className="font-black text-2xl text-slate-800 mb-2">Berkas Terkunci!</h3>
            <p className="text-sm text-slate-600 mb-6 leading-relaxed font-medium">
              Mohon maaf, berkas ini sedang dibuka dan diverifikasi oleh <b className="text-slate-800 bg-slate-100 px-2 py-0.5 rounded">{lockWarning.lockedBy}</b>.
            </p>
            
            {/* TOMBOL AMBIL ALIH PAKSA (Hanya Muncul untuk Admin) */}
            {userRole === 'admin' && (
              <button 
                onClick={() => handleSelect(lockWarning.pendingItem, true)}
                className="w-full px-5 py-3 mb-3 bg-rose-600 hover:bg-rose-700 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl active:scale-95"
              >
                Ambil Alih Paksa Berkas
              </button>
            )}

            <button 
              onClick={() => setLockWarning({ show: false, lockedBy: '', pendingItem: null })}
              className="w-full px-5 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-xl transition-all active:scale-95"
            >
              Kembali
            </button>
          </div>
        </div>
      )}

      {/* 2. MODAL SAAT DITENDANG OLEH ADMIN LAIN */}
      {kickedModal.show && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm px-4">
          <div className="bg-white p-6 rounded-xl max-w-sm text-center shadow-2xl transform scale-100 animate-in zoom-in-95 duration-200">
            <div className="w-16 h-16 bg-rose-100 text-rose-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertCircle size={32} />
            </div>
            <h3 className="font-bold text-xl text-slate-800 mb-2">Akses Terputus!</h3>
            <p className="text-sm text-slate-600 mb-6">
              Berkas ini telah diambil alih secara paksa oleh Admin: <b className="text-rose-600">{kickedModal.taken_by}</b>. Anda tidak bisa melanjutkan pengeditan.
            </p>
            <button 
              onClick={() => {
                setKickedModal({ show: false, taken_by: '' });
                handleBackToList(); // Fungsi yang sudah Anda miliki untuk menutup detail
              }}
              className="w-full bg-slate-800 hover:bg-slate-900 text-white font-bold py-3 px-4 rounded-lg transition-colors flex justify-center items-center gap-2"
            >
              <span>Tutup & Kembali ke Tabel (X)</span>
            </button>
          </div>
        </div>
      )}
      {showBatchModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md animate-fade-in-up">
            <h3 className="font-bold text-xl text-slate-800 mb-2">
              Cetak & Download PAK
            </h3>
            <p className="text-sm text-slate-600 mb-4">
              Anda akan menyiapkan {selectedRows.length} dokumen PAK.
              Pilih mode dokumen yang dibutuhkan sebelum mencetak.
            </p>

            <div className="mb-6">
              <label className="block text-sm font-bold text-slate-700 mb-2">
                Mode Dokumen PAK
              </label>

              <div className="space-y-2">

                <label
                  className={`block cursor-pointer rounded-xl border p-3 transition-all ${
                    printTteMode === 'with_tte'
                      ? 'border-emerald-500 bg-emerald-50 ring-1 ring-emerald-200'
                      : 'border-slate-200 bg-white hover:bg-slate-50'
                  }`}
                >
                  <div className="flex items-start gap-3">

                    <input
                      type="radio"
                      name="printTteMode"
                      value="with_tte"
                      checked={printTteMode === 'with_tte'}
                      onChange={() => setPrintTteMode('with_tte')}
                      className="mt-1"
                    />

                    <div>
                      <div className="font-bold text-sm text-slate-800">
                        PAK Dengan TTE
                      </div>

                      <div className="text-xs text-slate-500 mt-1">
                        Menampilkan visual tanda tangan elektronik
                        dan logo BSrE. Setelah PDF dibuat, lanjutkan
                        proses penandatanganan melalui BeSign Desktop.
                      </div>
                    </div>

                  </div>
                </label>


                <label
                  className={`block cursor-pointer rounded-xl border p-3 transition-all ${
                    printTteMode === 'without_tte'
                      ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-200'
                      : 'border-slate-200 bg-white hover:bg-slate-50'
                  }`}
                >
                  <div className="flex items-start gap-3">

                    <input
                      type="radio"
                      name="printTteMode"
                      value="without_tte"
                      checked={printTteMode === 'without_tte'}
                      onChange={() => setPrintTteMode('without_tte')}
                      className="mt-1"
                    />

                    <div>
                      <div className="font-bold text-sm text-slate-800">
                        PAK Tanpa TTE
                      </div>

                      <div className="text-xs text-slate-500 mt-1">
                        Bukan draft dan tidak memakai watermark DRAFT.
                        Visual tanda tangan elektronik dan logo BSrE
                        tidak ditampilkan.
                      </div>
                    </div>

                  </div>
                </label>

              </div>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-bold text-slate-700 mb-2">
                Nomor Urut Surat Awal
              </label>
              <div className="flex gap-3 items-center">
                <input
                  type="number"
                  value={batchStartNum}
                  onChange={(e) => setBatchStartNum(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg p-3 outline-none focus:border-blue-500 font-bold"
                />
                <button
                  onClick={() => setBatchStartNum(1)}
                  className="px-4 py-3 bg-rose-100 hover:bg-rose-200 text-rose-700 rounded-lg font-bold transition-all whitespace-nowrap"
                >
                  Reset (1)
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="block text-sm font-bold text-slate-700 mb-2">
                Tanggal Surat (Cetak PDF)
              </label>
              <input
                type="date"
                value={tanggalTtd}
                onChange={(e) => setTanggalTtd(e.target.value)}
                className="w-full border border-slate-300 rounded-lg p-3 outline-none focus:border-blue-500 bg-slate-50"
              />
            </div>

            <div className="mb-3 flex items-start gap-2 bg-emerald-50 p-3 rounded-lg border border-emerald-100">
              <input
                type="checkbox"
                id="useExistingPrintDate"
                checked={useExistingPrintDate}
                onChange={(e) => setUseExistingPrintDate(e.target.checked)}
                className="mt-1 w-4 h-4 text-emerald-600 rounded cursor-pointer"
              />
              <label
                htmlFor="useExistingPrintDate"
                className="text-sm text-slate-700 cursor-pointer"
              >
                <span className="font-bold block text-emerald-800">
                  Pertahankan Tanggal Cetak Lama
                </span>
                Jika pegawai sudah pernah dicetak, tanggal lama tetap digunakan.
                Pegawai yang belum punya tanggal cetak akan memakai tanggal di atas.
              </label>
            </div>

            <div className="mb-4 flex items-start gap-2 bg-blue-50 p-3 rounded-lg border border-blue-100">
              <input
                type="checkbox"
                id="useExisting"
                checked={useExistingNumber}
                onChange={(e) => setUseExistingNumber(e.target.checked)}
                className="mt-1 w-4 h-4 text-blue-600 rounded cursor-pointer"
              />
              <label htmlFor="useExisting" className="text-sm text-slate-700 cursor-pointer">
                <span className="font-bold block text-blue-800">Pertahankan Nomor Lama</span>
                Jika pegawai sudah punya nomor, sistem tidak akan menimpanya dengan nomor urut baru.
              </label>
            </div>

            <div className="mb-6 border border-cyan-200 bg-cyan-50 rounded-xl p-4">
              <div className="flex items-start gap-3">
                <Lock size={18} className="text-cyan-700 mt-0.5 shrink-0" />
                <div>
                  <div className="font-bold text-sm text-slate-800">
                    Proses Dokumen PAK
                  </div>
                  <div className="text-xs text-slate-600 mt-1 leading-relaxed">
                    SIPAK memproses dokumen satu per satu agar tetap ringan meskipun jumlahnya
                    ratusan. Maksimal 20 PDF dimasukkan ke setiap ZIP. Mode Dengan TTE
                    dilanjutkan melalui BeSign Desktop. Mode Tanpa TTE menghasilkan PDF
                    bersih tanpa visual tanda tangan elektronik maupun logo BSrE.
                  </div>
                  <div className="text-xs font-semibold text-amber-700 mt-2">
                    Pastikan mode dokumen yang dipilih sesuai kebutuhan sebelum mencetak.
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowBatchModal(false)}
                className="px-5 py-2.5 bg-slate-100 text-slate-700 hover:bg-slate-200 rounded-xl font-bold transition-all"
              >
                Batal
              </button>
              <button
                onClick={handleStartBatchProcess}
                className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold shadow-lg transition-all flex items-center gap-2"
              >
                <Printer size={18}/> Mulai Cetak
              </button>
            </div>
          </div>
        </div>
      )}
      {showBulkNipModal && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
    <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md animate-fade-in-up">
      <h3 className="font-bold text-xl text-slate-800 mb-2">Pilih Massal via NIP</h3>
      <p className="text-sm text-slate-600 mb-4">Paste/masukkan daftar NIP dari Excel ke kotak di bawah (bisa dipisah dengan enter, spasi, atau koma).</p>
      
      <textarea
          rows="8"
          placeholder="198001012010011001&#10;198201012010011002&#10;..."
          value={bulkNips}
          onChange={(e) => setBulkNips(e.target.value)}
          className="w-full border border-slate-300 rounded-lg p-3 outline-none focus:border-indigo-500 font-mono text-sm mb-4"
      ></textarea>

      <div className="flex justify-end gap-3">
        <button onClick={() => setShowBulkNipModal(false)} className="px-5 py-2.5 bg-slate-100 text-slate-700 hover:bg-slate-200 rounded-xl font-bold transition-all">Batal</button>
        <button onClick={handleSelectByNips} className="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold shadow-lg transition-all flex items-center gap-2">
          <CheckCircle size={18}/> Cari & Centang
        </button>
      </div>
    </div>
  </div>
)}

      {showRekapModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
            <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col animate-fade-in-up">
                <div className="flex justify-between items-center border-b border-slate-200 pb-4 mb-4 shrink-0">
                    <h3 className="font-bold text-xl text-slate-800 flex items-center gap-2">
                        <FileText className="text-rose-600"/> Rekap Guru Belum Upload Berkas
                    </h3>
                    <button onClick={() => setShowRekapModal(false)} className="text-slate-400 hover:bg-rose-100 hover:text-rose-600 p-1 rounded-lg transition-colors"><X size={24}/></button>
                </div>

                <div className="overflow-y-auto custom-scrollbar pr-2 pb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <h4 className="font-bold text-sm text-slate-600 mb-3 bg-slate-100 p-2.5 rounded-lg border border-slate-200">Berdasarkan Kecamatan</h4>
                            <div className="space-y-1">
                                {Object.keys(rekapKecamatan).length === 0 && <p className="text-sm text-slate-400 pl-2">Tidak ada data.</p>}
                                {Object.entries(rekapKecamatan).sort((a,b) => b[1]-a[1]).map(([kec, count]) => (
                                    <div 
                                      key={kec} 
                                      onClick={() => handleRekapClick('kecamatan', kec)}
                                      className="flex justify-between items-center text-sm border-b border-slate-100 pb-1.5 cursor-pointer hover:bg-rose-50 p-1.5 rounded transition-colors group"
                                    >
                                        <span className="text-slate-700 font-medium group-hover:text-rose-700 flex items-center gap-2">
                                           <ChevronRight size={14} className="text-rose-300 opacity-0 group-hover:opacity-100 transition-opacity"/> 
                                           {kec}
                                        </span>
                                        <span className="font-bold text-rose-600 bg-rose-50 px-2 py-0.5 rounded border border-rose-100">{count}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <h4 className="font-bold text-sm text-slate-600 mb-3 bg-slate-100 p-2.5 rounded-lg border border-slate-200">Berdasarkan Jabatan</h4>
                            <div className="space-y-1">
                                {Object.keys(rekapJabatan).length === 0 && <p className="text-sm text-slate-400 pl-2">Tidak ada data.</p>}
                                {Object.entries(rekapJabatan).sort((a,b) => b[1]-a[1]).map(([jab, count]) => (
                                    <div 
                                      key={jab} 
                                      onClick={() => handleRekapClick('jabatan', jab)}
                                      className="flex justify-between items-center text-sm border-b border-slate-100 pb-1.5 cursor-pointer hover:bg-rose-50 p-1.5 rounded transition-colors group"
                                    >
                                        <span className="text-slate-700 font-medium truncate pr-2 group-hover:text-rose-700 flex items-center gap-2" title={jab}>
                                            <ChevronRight size={14} className="text-rose-300 opacity-0 group-hover:opacity-100 transition-opacity shrink-0"/> 
                                            <span className="truncate">{jab}</span>
                                        </span>
                                        <span className="font-bold text-rose-600 bg-rose-50 px-2 py-0.5 rounded border border-rose-100 shrink-0">{count}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-500 text-center flex items-center justify-center gap-1">
                   <Info size={12}/> Klik salah satu nama untuk memfilter dan melihat rincian di tabel.
                </div>
            </div>
        </div>
      )}

      {toast.show && (
        <div className={`fixed top-6 right-6 z-[9999] flex items-center gap-3 px-6 py-4 rounded-xl shadow-2xl text-white animate-fade-in-up ${toast.type === 'success' ? 'bg-emerald-600' : 'bg-rose-600'}`}>
          {toast.type === 'success' ? <CheckCircle size={24} /> : <XCircle size={24} />}
          <p className="font-semibold">{toast.message}</p>
        </div>
      )}

      {confirmModal.show && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in-up">
            <div className="bg-blue-50 p-5 flex items-center gap-4 border-b border-blue-100">
              <div className="bg-blue-100 p-2.5 rounded-full text-blue-600"><Info size={24} /></div>
              <h3 className="font-bold text-lg text-blue-900">{confirmModal.title}</h3>
            </div>
            <div className="p-6">
              <p className="text-slate-600 mb-6">{confirmModal.message}</p>
              <div className="flex justify-end gap-3">
                <button onClick={() => setConfirmModal({ ...confirmModal, show: false })} className="px-5 py-2.5 bg-slate-100 text-slate-700 hover:bg-slate-200 rounded-xl font-medium transition-all">Batal</button>
                <button onClick={confirmModal.onConfirm} className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold shadow-lg transition-all">{confirmModal.actionBtn}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showApproveModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
          <div className="bg-white rounded-xl p-6 w-[450px] shadow-2xl animate-fade-in-up">
            <h3 className="font-bold text-emerald-700 mb-2 text-xl flex items-center gap-2"><CheckCircle size={24}/> Persetujuan PAK</h3>
            <p className="text-sm text-slate-600 mb-4 leading-relaxed border-b border-slate-100 pb-4">Sistem akan secara otomatis menentukan kelayakan Angka Kredit guru ini berdasarkan kalkulasi data.</p>
            
            <div className="mb-6 p-4 rounded-xl border border-slate-200 bg-slate-50">
               <p className="text-xs text-slate-500 uppercase font-bold mb-3 tracking-wider">Hasil Analisis Sistem:</p>
               
               <div className="flex justify-between items-center mb-1">
                  <span className="font-medium text-slate-600 text-sm">AK Baru (Utk Pangkat):</span>
                  <span className="font-bold text-slate-800">{formatNum(calculation?.akKonversiBaru + calculation?.akPG)}</span>
               </div>
               <div className="flex justify-between items-center mb-2">
                  <span className="font-medium text-slate-600 text-sm">Syarat Minimal Pangkat:</span>
                  <span className="font-bold text-slate-800">{calculation?.golInfo?.akLama}</span>
               </div>

               <div className="border-t border-slate-200 my-2"></div>

               <div className="flex justify-between items-center mb-1">
                  <span className="font-medium text-slate-600 text-sm">AK Kumulatif (Utk Jenjang):</span>
                  <span className="font-bold text-slate-800">{formatNum(calculation?.totalKumulatif)}</span>
               </div>
               <div className="flex justify-between items-center mb-4">
                  <span className="font-medium text-slate-600 text-sm">Syarat Minimal Jenjang:</span>
                  <span className="font-bold text-slate-800">{calculation?.golInfo?.jenjang !== -1 ? calculation?.golInfo?.jenjang : '-'}</span>
               </div>

               <div className={`p-3 rounded-lg border flex items-center gap-2 font-bold ${calculation?.calcAutoStatusAk === 'Cukup' ? 'bg-emerald-100 text-emerald-800 border-emerald-200' : 'bg-rose-100 text-rose-800 border-rose-200'}`}>
                  {calculation?.calcAutoStatusAk === 'Cukup' ? <CheckCircle size={18}/> : <XCircle size={18}/>} 
                  Status: ANGKA KREDIT {calculation?.calcAutoStatusAk?.toUpperCase()}
               </div>
            </div>

            <div className="flex justify-end gap-3">
              <button onClick={() => setShowApproveModal(false)} className="px-5 py-2.5 bg-slate-100 hover:bg-slate-200 rounded-lg font-medium text-slate-700 transition-all">Batal</button>
               
              <button 
                 onClick={executeApprove} 
                 disabled={selectedItem?.status?.toLowerCase() === 'disetujui'}
                 className={`px-5 py-2.5 rounded-lg font-bold shadow-lg transition-all ${selectedItem?.status?.toLowerCase() === 'disetujui' ? 'bg-slate-300 text-slate-500 cursor-not-allowed' : 'bg-emerald-600 hover:bg-emerald-700 text-white'}`}
              >
                {selectedItem?.status?.toLowerCase() === 'disetujui' ? 'Sudah Disetujui' : 'Setujui Berkas'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRejectModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 px-4">                
          <div className="bg-white rounded-xl p-6 w-[400px]">
            <h3 className="font-bold text-red-600 mb-2">Tolak Berkas</h3>
            <textarea className="w-full border rounded p-2 mb-4 outline-none focus:border-red-500" rows="4" placeholder="Alasan penolakan..." value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
            <div className="flex justify-end gap-2">
              <button onClick={() => setShowRejectModal(false)} className="px-4 py-2 bg-slate-100 rounded">Batal</button>
              <button onClick={submitRejection} disabled={!rejectReason} className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50">Kirim Penolakan</button>
            </div>
          </div>
        </div>
      )}

      {isProcessingZip && (
        <div className="fixed inset-0 z-[999] bg-slate-900/90 backdrop-blur-sm flex flex-col items-center justify-center text-white">
          <Loader2 className="animate-spin mb-4 text-blue-400" size={64} />
          <h2 className="text-2xl font-bold mb-2">Menyiapkan Dokumen TTE...</h2>
          <p className="text-lg bg-slate-800 px-6 py-2 rounded-full">{progressStatus.current} dari {progressStatus.total} Guru</p>
          <p className="text-sm mt-4 text-slate-400">{progressStatus.text}</p>
        </div>
      )}

      {/* FAST PRINT RENDERER:
          Hanya satu PAK aktif yang berada di DOM.
          Diletakkan jauh di luar layar tetapi tetap dirender normal
          agar html2canvas tidak perlu memproses 277 preview sekaligus.
      */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: '-12000px',
          width: '210mm',
          zIndex: -1000,
          pointerEvents: 'none',
          background: '#fff'
        }}
      >
        {activePrintItem && (
          <TabelPreviewPAK
            key={`fast-${activePrintItem.item.pak_id}`}
            indexId="fast"
            calculation={activePrintItem.calculation}
            selectedItem={activePrintItem.item}
            nomorSurat={activePrintItem.generatedNomor}
            isDraft={false}
            forPrint={true}
            showTte={printTteMode === 'with_tte'}
            tanggalTtd={activePrintItem.generatedTanggalTtd}
          />
        )}
      </div>

      <div className={isProcessingZip ? 'hidden' : 'block'}>
        {view === 'list' ? (
          <div className="p-4 md:p-8 max-w-[1600px] mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-end md:items-center mb-6 gap-4">
              <h1 className="text-2xl font-bold text-slate-800">Daftar Verifikasi PAK</h1>
              <div className="flex gap-3">
                <button onClick={exportToExcel} className="bg-emerald-600 text-white px-4 py-2 rounded shadow flex gap-2 items-center hover:bg-emerald-700 text-sm font-bold">
                  <FileSpreadsheet size={16} /> Export Excel Lengkap
                </button>
                <button onClick={() => setShowBulkNipModal(true)} className="bg-indigo-600 text-white px-4 py-2 rounded shadow flex gap-2 items-center hover:bg-indigo-700 text-sm font-bold">
                  <Filter size={16} /> Pilih via NIP
                </button>
                {userRole === 'admin' && selectedRows.length > 0 && (
                  <button onClick={handleOpenBatchModal} className="bg-blue-600 text-white px-4 py-2 rounded shadow flex gap-2 items-center hover:bg-blue-700 text-sm font-bold">
                    <Printer size={16} /> Cetak & Download ({selectedRows.length})
                  </button>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4">
              
              <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col hover:border-blue-300 transition-colors">
                 <div className="flex items-center gap-2 text-slate-500 text-[11px] font-bold uppercase tracking-wider mb-4">
                    <BarChart2 size={16} className="text-blue-500"/> Status Usulan
                 </div>
                 <div className="flex items-end justify-between mt-auto">
                    <div className="cursor-pointer hover:opacity-70 group" onClick={() => applyDashboardFilter('status', 'berkas_masuk')}>
                       <div className="text-3xl font-black text-slate-800 leading-none group-hover:text-blue-600">{stats.total}</div>
                       <div className="text-xs text-slate-500 mt-1">Total Berkas Masuk</div>
                    </div>
                    <div className="text-right text-[11px] font-bold space-y-1">
                       <div className="text-amber-600 bg-amber-50 px-2 py-0.5 rounded cursor-pointer hover:bg-amber-100 hover:scale-105 transition-transform" onClick={() => applyDashboardFilter('status', 'pending')}>{stats.pending} Pending</div>
                       <div className="text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded cursor-pointer hover:bg-emerald-100 hover:scale-105 transition-transform" onClick={() => applyDashboardFilter('status', 'disetujui')}>{stats.disetujui} Disetujui</div>
                       <div className="text-rose-600 bg-rose-50 px-2 py-0.5 rounded cursor-pointer hover:bg-rose-100 hover:scale-105 transition-transform" onClick={() => applyDashboardFilter('status', 'ditolak')}>{stats.ditolak} Ditolak</div>
                    </div>
                 </div>
               </div>

              <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col hover:border-emerald-300 transition-colors">
                 <div className="flex items-center gap-2 text-slate-500 text-[11px] font-bold uppercase tracking-wider mb-4">
                    <CheckSquare size={16} className="text-emerald-500"/> Kelayakan AK
                  </div>
                 <div className="flex items-end justify-between mt-auto w-full">
                    <div className="w-1/2 border-r border-slate-100 pr-3 cursor-pointer hover:opacity-70 group" onClick={() => applyDashboardFilter('statusAk', 'cukup')}>
                       <div className="text-2xl font-black text-emerald-600 leading-none group-hover:scale-110 origin-left transition-transform">{stats.akCukup}</div>
                       <div className="text-xs text-slate-500 mt-1 font-medium">AK Cukup</div>
                    </div>
                    <div className="w-1/2 pl-3 text-right cursor-pointer hover:opacity-70 group" onClick={() => applyDashboardFilter('statusAk', 'tidak cukup')}>
                       <div className="text-2xl font-black text-rose-600 leading-none group-hover:scale-110 origin-right transition-transform">{stats.akTidakCukup}</div>
                        <div className="text-xs text-slate-500 mt-1 font-medium">Tidak Cukup</div>
                    </div>
                 </div>
              </div>

              <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col cursor-pointer hover:border-purple-300 hover:shadow-md transition-all group" onClick={() => applyDashboardFilter('cetakStatus', 'sudah')}>
                 <div className="flex items-center gap-2 text-slate-500 text-[11px] font-bold uppercase tracking-wider mb-4">
                    <Printer size={16} className="text-purple-500"/> Sudah Dicetak
                 </div>
                 <div className="mt-auto">
                   <div className="text-3xl font-black text-slate-800 leading-none group-hover:text-purple-600">{stats.sudahDicetak}</div>
                    <div className="text-xs text-slate-500 mt-1 font-medium">Pegawai (Dari {stats.disetujui} Disetujui)</div>
                 </div>
              </div>

              <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col cursor-pointer hover:border-amber-400 hover:shadow-md transition-all group" onClick={() => applyDashboardFilter('cetakStatus', 'belum')}>
                 <div className="flex items-center gap-2 text-slate-500 text-[11px] font-bold uppercase tracking-wider mb-4">
                    <FileText size={16} className="text-amber-500"/> Antrean Cetak
                 </div>
                 <div className="mt-auto">
                    <div className="text-3xl font-black text-slate-800 leading-none group-hover:text-amber-500">{stats.belumDicetak}</div>
                    <div className="text-xs text-slate-500 mt-1 font-medium">Menunggu (Dari {stats.disetujui} Disetujui)</div>
                 </div>
              </div>

              <div className="bg-rose-50 p-4 rounded-xl border border-rose-200 shadow-sm flex flex-col hover:shadow-md transition-all relative overflow-hidden group cursor-pointer" onClick={() => applyDashboardFilter('uploadStatus', 'belum')}>
                 <div className="absolute -right-4 -top-4 text-rose-100 opacity-60"><FileText size={80} /></div>
                 
                 <div className="flex items-center justify-between text-rose-700 text-[11px] font-bold uppercase tracking-wider mb-4 relative z-10">
                    <div className="flex items-center gap-2"><FileText size={16}/> Belum Upload</div>
                    {(userRole === 'admin' || userRole === 'satlak') && (
                       <button onClick={(e) => { e.stopPropagation(); setShowRekapModal(true); }} className="px-2 py-1 bg-white text-rose-600 hover:bg-rose-600 hover:text-white rounded border border-rose-200 transition-colors shadow-sm capitalize font-bold text-[10px]">
                           Lihat Rekap
                       </button>
                    )}
                 </div>
                 <div className="mt-auto relative z-10">
                    <div className="text-3xl font-black text-rose-700 leading-none group-hover:scale-105 origin-left transition-transform">{stats.belumUpload}</div>
                    <div className="text-[11px] text-rose-600/80 mt-1 font-medium">Guru Belum Ada Berkas</div>
                 </div>
              </div>
            </div>

            {(filters.jabatan || filters.cetakStatus) && (
               <div className="mb-4 flex flex-wrap items-center gap-2 animate-fade-in-up">
                 <span className="text-sm font-medium text-slate-500">Tabel sedang difilter berdasarkan:</span>
                  
                  {filters.jabatan && (
                     <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-bold border border-blue-200 shadow-sm">
                       Jabatan: {filters.jabatan}
                        <button onClick={() => setFilters(p => ({...p, jabatan: ''}))} className="hover:text-red-500 hover:bg-blue-200 p-0.5 rounded-full transition-colors"><X size={14}/></button>
                     </span>
                  )}

                  {filters.cetakStatus && (
                     <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-purple-100 text-purple-700 rounded-lg text-xs font-bold border border-purple-200 shadow-sm">
                        Cetak: {filters.cetakStatus === 'sudah' ? 'Sudah Dicetak' : 'Antrean Cetak'}
                        <button onClick={() => setFilters(p => ({...p, cetakStatus: ''}))} className="hover:text-red-500 hover:bg-purple-200 p-0.5 rounded-full transition-colors"><X size={14}/></button>
                     </span>
                  )}
               </div>
             )}
            
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto">
              <table className="w-full text-left whitespace-nowrap relative">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500 text-xs uppercase relative z-20">
                  <tr>
                   {userRole === 'admin' && (
                        <th className="p-4 w-10 text-center">
                            <input 
                               type="checkbox" 
                                onChange={toggleSelectAll} 
                                checked={
                                   currentItems.filter(sub => !sub.is_empty).length > 0 && 
                                    currentItems.filter(sub => !sub.is_empty).every(sub => selectedRows.includes(sub.pak_id))
                                } 
                                className="cursor-pointer"
                            />
                        </th>
                    )}
                    <th className="p-4">NIP / Nama</th>
                    <th className="p-4 w-20">Gol.</th>
                    <th className="p-4">Jenis PAK</th>
                    <th className="p-4">Kecamatan</th>
                    <th className="p-4 min-w-[200px]">Unit Kerja</th>
                    <th className="p-4">Dokumen</th> 
                    {/* TAMBAHKAN BARIS INI */}
                    <th 
  className="p-4 cursor-pointer hover:bg-slate-200 transition-colors select-none group" 
  onClick={() => requestSort('tgl_usul')}
>
  <div className="flex items-center gap-1">
    Tgl Usulan
    <span className="text-[10px] text-slate-400 bg-white px-1 rounded border border-slate-200 group-hover:border-slate-300">
        {sortConfig.key === 'tgl_usul' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '↕'}
    </span>
  </div>
</th>

<th 
  className="p-4 cursor-pointer hover:bg-slate-200 transition-colors select-none group" 
  onClick={() => requestSort('tgl_validasi')}
>
  <div className="flex items-center gap-1">
    Tgl Validasi
    <span className="text-[10px] text-slate-400 bg-white px-1 rounded border border-slate-200 group-hover:border-slate-300">
        {sortConfig.key === 'tgl_validasi' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '↕'}
    </span>
  </div>
</th>
                    <th className="p-4">Status Usulan</th>
                    <th className="p-4">Status AK</th>
                    <th className="p-4 bg-amber-50 text-amber-800 border-l border-amber-200">No. Surat</th>
                    <th className="p-4 bg-amber-50 text-amber-800">Tgl Cetak</th>
                    
                    {/* KOLOM AKSI STICKY KANAN */}
                    <th className="p-4 text-center sticky right-0 bg-slate-50 z-30 shadow-[-4px_0_6px_-1px_rgba(0,0,0,0.05)] border-l border-slate-200">Aksi</th>
                  </tr>
                  <tr className="bg-slate-100/50 border-b border-slate-200">
                    {userRole === 'admin' && <th className="px-4 py-2"></th>}
                    <th className="px-4 py-2"><input type="text" placeholder="Cari..." className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.namaNip} onChange={(e) => handleFilterChange(e, 'namaNip')} /></th>
                    <th className="px-4 py-2"><input type="text" placeholder="Gol" className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.golongan} onChange={(e) => handleFilterChange(e, 'golongan')} /></th>
                    <th className="px-4 py-2">
                      <select className="w-full px-2 py-1 text-xs border rounded font-normal bg-white" value={filters.jenisPak} onChange={(e) => handleFilterChange(e, 'jenisPak')}>
                        <option value="">Semua</option><option value="integrasi">Integrasi</option><option value="konversi">Konversi</option>
                      </select>
                    </th>
                    
                    <th className="px-4 py-2">
                      {userRole === 'admin' ? (
                        <select 
                          className="w-full px-2 py-1 text-xs border rounded font-normal outline-none bg-white text-slate-600" 
                          value={filters.kecamatan} 
                          onChange={(e) => handleFilterChange(e, 'kecamatan')}
                        >
                          <option value="">Semua Kec</option>
                          {kecamatanList.map(kec => (
                           <option key={kec} value={kec}>{kec}</option>
                          ))}
                        </select>
                      ) : (
                        <input 
                          type="text" 
                          placeholder="Cari Kec..." 
                          className="w-full px-2 py-1 text-xs border rounded font-normal" 
                          value={filters.kecamatan} 
                          onChange={(e) => handleFilterChange(e, 'kecamatan')} 
                        />
                     )}
                    </th>
                    
                    <th className="px-4 py-2"><input type="text" placeholder="Cari Unit..." className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.unitKerja} onChange={(e) => handleFilterChange(e, 'unitKerja')} /></th>
                     
                    <th className="px-4 py-2">
                      <select className="w-full px-2 py-1 text-xs border rounded font-normal bg-white" value={filters.uploadStatus} onChange={(e) => handleFilterChange(e, 'uploadStatus')}>
                        <option value="">Semua</option><option value="sudah">Sudah</option><option value="belum">Belum</option>
                       </select>
                    </th>
<th className="px-4 py-2">
                      <input type="text" placeholder="Cari Tgl..." className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.tglUsul} onChange={(e) => handleFilterChange(e, 'tglUsul')} />
                    </th>
                    <th className="px-4 py-2">
                      <input type="text" placeholder="Cari Tgl..." className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.tglValidasi} onChange={(e) => handleFilterChange(e, 'tglValidasi')} />
                    </th>
                    <th className="px-4 py-2">
                      <select className="w-full px-2 py-1 text-xs border rounded font-normal bg-white" value={filters.status} onChange={(e) => handleFilterChange(e, 'status')}>
                        <option value="">Semua</option>
                        <option value="berkas_masuk">Berkas Masuk</option>
                        <option value="belum usul">Belum Usul</option>
                        <option value="pending">Pending</option>
                        <option value="disetujui">Disetujui</option>
                        <option value="ditolak">Ditolak</option>
                      </select>
                    </th>
                   <th className="px-4 py-2">
                      <select className="w-full px-2 py-1 text-xs border rounded font-normal bg-white" value={filters.statusAk} onChange={(e) => handleFilterChange(e, 'statusAk')}>
                        <option value="">Semua</option><option value="cukup">Cukup</option><option value="tidak cukup">Tidak Cukup</option>
                       </select>
                    </th>
                    <th className="px-4 py-2 border-l border-amber-200"><input type="text" placeholder="Cari No. Surat..." className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.nomorSurat} onChange={(e) => handleFilterChange(e, 'nomorSurat')} /></th>
                    <th className="px-4 py-2"><input type="text" placeholder="Cari Tgl..." className="w-full px-2 py-1 text-xs border rounded font-normal" value={filters.tglCetak} onChange={(e) => handleFilterChange(e, 'tglCetak')} /></th>
                    
                    {/* KOLOM AKSI STICKY KANAN (HEADER 2) */}
                    <th className="px-4 py-2 text-center text-slate-400 sticky right-0 bg-slate-100 z-30 shadow-[-4px_0_6px_-1px_rgba(0,0,0,0.05)] border-l border-slate-200"><Filter size={14} className="mx-auto" /></th>
                  </tr>
                 </thead>

                <tbody className="divide-y divide-slate-100 text-sm relative z-0">
                  {isLoadingData ? (
                    <tr>
                      <td colSpan="100%" className="p-16 text-center">
                        <Loader2 className="w-8 h-8 animate-spin text-blue-500 mx-auto mb-3" />
                        <p className="text-slate-500 font-medium">Memuat data dari server...</p>
                      </td>
                    </tr>
                  ) : currentItems.length === 0 ? (
                    <tr><td colSpan="100%" className="p-12 text-center text-slate-400 font-medium bg-slate-50">Data tidak ditemukan atau belum ada usulan.</td></tr>
                  ) : (
                    currentItems.map((sub) => (
                      <tr key={sub.pak_id} className={`hover:bg-slate-50 transition-colors group ${sub.is_empty ? 'opacity-60 bg-slate-50/50' : 'bg-white'}`}>
                        {userRole === 'admin' && (
                          <td className="p-4 text-center">
                            {!sub.is_empty && <input type="checkbox" onChange={() => toggleRowSelection(sub.pak_id)} checked={selectedRows.includes(sub.pak_id)} />}
                          </td>
                        )}
                        <td className="p-4">
                          <div className="font-bold text-slate-800 flex items-center gap-2">
                            {sub.full_name}
                            {sub.catatan_penolakan && sub.status?.toLowerCase() === 'pending' && (
                              <span className="bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded text-[10px] border border-amber-200 uppercase leading-none">Revisi</span>
                            )}
                          </div>
                          <div className="text-xs text-slate-500">{sub.nip}</div>
                        </td>
                        <td className="p-4"><span className="bg-slate-100 px-2 py-1 rounded text-xs font-bold text-slate-600">{sub.golongan}</span></td>
                        <td className="p-4">
                          <span className={`px-2 py-1 rounded text-xs font-bold border ${sub.jenis_pak?.toLowerCase() === 'konversi' ? 'bg-purple-50 text-purple-700 border-purple-200' : 'bg-slate-100 text-slate-500 border-slate-200'}`}>
                            {sub.is_empty ? '-' : (sub.jenis_pak || 'Integrasi')}
                          </span>
                        </td>
                        <td className="p-4 text-xs font-bold text-slate-600">{normalizeKecamatan(sub.kecamatan)}</td>
                        <td className="p-4 text-xs whitespace-normal max-w-[200px] leading-tight">{sub.unit_kerja}</td>
                        
                        <td className="p-4">
                          {(!sub.dokumen || sub.dokumen.length === 0) ? (
                              <span className="text-rose-600 bg-rose-50 px-2 py-1 rounded text-[10px] font-bold border border-rose-200">Belum</span>
                          ) : (
                              <span className="text-emerald-600 bg-emerald-50 px-2 py-1 rounded text-[10px] font-bold border border-emerald-200">Sudah</span>
                          )}
                        </td>
                        {/* TAMBAHKAN BARIS INI */}
                       {/* Kolom Tgl Usul */}
                        <td className="p-4 text-[11px] font-bold text-slate-600">
                          {(sub.tgl_input || sub.updated_at)
                            ? new Date(sub.tgl_input || sub.updated_at).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) 
                            : '-'}
                        </td>

                        {/* Kolom Tgl Validasi */}
                        <td className="p-4 text-[11px] font-bold text-slate-600">
                          {(sub.tgl_verifikasi || (['Disetujui', 'Ditolak'].includes(sub.status) ? sub.updated_at : null))
                            ? new Date(sub.tgl_verifikasi || (['Disetujui', 'Ditolak'].includes(sub.status) ? sub.updated_at : null)).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) 
                            : (sub.status === 'Pending' ? <span className="text-amber-500 italic">Menunggu</span> : '-')}
                        </td>
                        {/* ========================================== */}
                        <td className="p-4 align-top">
                          <div className="flex flex-col items-start gap-1.5">
                              <span className={`px-2 py-1 rounded text-[11px] font-bold ${
                                 sub.status?.toLowerCase() === 'disetujui' ? 'bg-green-100 text-green-700' : 
                                 sub.status?.toLowerCase() === 'ditolak' ? 'bg-red-100 text-red-700' : 
                                 sub.status?.toLowerCase() === 'belum usul' || sub.is_empty ? 'bg-slate-200 text-slate-600' :
                                 'bg-yellow-100 text-yellow-700'
                              }`}>
                                 {sub.status || 'Pending'}
                              </span>
                              
                              {/* PERBAIKAN: Kotak catatan Ditolak/Revisi (Menggunakan catatan_penolakan API) */}
                              {((sub.status?.toLowerCase() === 'ditolak') || (sub.status?.toLowerCase() === 'pending' && sub.catatan_penolakan)) && (
                                <div 
                                   className="mt-1 text-[10px] text-rose-700 bg-rose-50 p-1.5 rounded border border-rose-200 leading-tight w-[160px] whitespace-normal break-words shadow-sm" 
                                   title={sub.catatan_penolakan || 'Tidak ada catatan dari sistem'}
                                >
                                  <span className="font-bold block mb-0.5 border-b border-rose-200 pb-0.5">Catatan:</span>
                                  <span className="line-clamp-3">{sub.catatan_penolakan || 'Tidak ada catatan.'}</span>
                                </div>
                              )}
                          </div>
                        </td>

                        <td className="p-4 text-xs font-bold text-slate-600">
                          {sub.status_ak && !sub.is_empty ? (
                            <span className={`px-2 py-1 rounded text-[10px] ${sub.status_ak === 'Cukup' ? 'bg-emerald-50 text-emerald-600 border border-emerald-200' : 'bg-rose-50 text-rose-600 border border-rose-200'}`}>
                              {sub.status_ak}
                             </span>
                          ) : '-'}
                        </td>
                        <td className="p-4 font-bold text-xs border-l border-slate-100 text-amber-700">{sub.nomor_surat || '-'}</td>
                        <td className="p-4 text-xs text-slate-500">{sub.tgl_cetak ? new Date(sub.tgl_cetak).toLocaleDateString('id-ID') : '-'}</td>
                        
                        {/* KOLOM AKSI STICKY KANAN (BODY) */}
                        <td className={`p-4 text-center sticky right-0 z-10 shadow-[-4px_0_6px_-1px_rgba(0,0,0,0.05)] border-l border-slate-100 transition-colors ${sub.is_empty ? 'bg-slate-50' : 'bg-white group-hover:bg-slate-50'}`}>
                          {sub.is_empty ? (
                              <span className="text-[10px] text-slate-400 italic">Data Kosong</span>
                          ) : (
                              <button onClick={() => handleSelect(sub)} className="text-blue-600 hover:bg-blue-100 bg-blue-50 px-3 py-1.5 rounded text-xs font-bold inline-flex items-center gap-1 border border-blue-200 transition-colors shadow-sm">
                                Buka <ChevronRight size={14}/>
                              </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {filteredSubmissions.length > 0 && !isLoadingData && (
              <div className="flex justify-between items-center mt-6 bg-white p-4 rounded-xl border shadow-sm flex-wrap gap-4">
                <div className="flex items-center gap-4">
                  <span className="text-sm text-slate-600">
                    Menampilkan halaman <b>{currentPage}</b> dari <b>{totalPages}</b> (Total {filteredSubmissions.length} Data)
                  </span>
                  
                  {/* AKSES DROPDOWN BARIS PER HALAMAN UNTUK ADMIN DAN SATLAK */}
                 {(userRole === 'admin' || userRole === 'satlak') && (
                    <div className="flex items-center gap-2 border-l border-slate-200 pl-4">
                      <span className="text-sm text-slate-500">Baris per halaman:</span>
                      <select
                        value={itemsPerPage >= 999999 ? 'all' : itemsPerPage}
                        onChange={(e) => {
                          const val = e.target.value;
                          setItemsPerPage(val === 'all' ? 999999 : Number(val));
                           setCurrentPage(1);
                        }}
                        className="border border-slate-300 rounded px-2 py-1 text-sm outline-none focus:border-blue-500 bg-slate-50 font-bold"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="all">Semua</option>
                      </select>
                    </div>
                  )}
                 </div>

                <div className="flex gap-2">
                  <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="px-4 py-2 border rounded text-sm font-bold hover:bg-slate-50 disabled:opacity-50">Sebelumnya</button>
                  <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} className="px-4 py-2 border rounded text-sm font-bold hover:bg-slate-50 disabled:opacity-50">Selanjutnya</button>
                 </div>
              </div>
            )}
          </div>
        ) : (
          <div className="p-4 md:p-8 max-w-[1400px] mx-auto relative">
           
           {/* ============================================================== */}
            {/* HEADER KEMBALI - DIBUAT STICKY TOP AGAR SELALU MUNCUL SAAT SCROLL */}
           {/* ============================================================== */}
           <div className="sticky top-0 z-40 bg-[#F8FAFC] pt-4 md:pt-8 pb-4 -mt-4 md:-mt-8 mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-slate-200/50">
              <button onClick={handleBackToList} className="flex items-center text-slate-500 hover:text-slate-800 bg-white px-4 py-2 rounded-lg border shadow-sm w-max shrink-0 transition-colors">
                <ArrowLeft size={18} className="mr-2"/> Kembali
              </button>
              
              <div className="bg-white px-5 py-2.5 rounded-lg border shadow-sm w-full sm:w-auto text-left sm:text-right border-l-4 border-l-blue-500">
                <h2 className="text-base md:text-lg font-bold text-slate-800 leading-tight">{selectedItem?.full_name}</h2>
                <p className="text-xs md:text-sm text-slate-500 font-medium mt-0.5">
                  NIP. {selectedItem?.nip} <span className="mx-1.5 text-slate-300">|</span> {selectedItem?.unit_kerja}
                </p>
              </div>
            </div>

            {selectedItem?.catatan_penolakan && (
              <div className="bg-amber-50 p-4 rounded-xl border border-amber-200 mb-6 flex gap-3 items-start shadow-sm animate-fade-in-up">
                 <AlertCircle size={24} className="text-amber-600 shrink-0" />
                <div>
                   <h4 className="font-bold text-amber-900 text-sm mb-1 uppercase tracking-wider">Fokus Pengecekan (Catatan Penolakan Sebelumnya)</h4>
                   <p className="text-amber-800 text-sm whitespace-pre-line leading-relaxed">{selectedItem.catatan_penolakan}</p>
                </div>
               </div>
            )}

            <div className="flex flex-col lg:flex-row gap-6 items-start">
              <div className="w-full lg:w-1/3 shrink-0 lg:sticky lg:top-32">
                {isClosed && userRole === 'satlak' && (
                  <div className="bg-red-100 text-red-800 p-3 rounded-lg mb-4 text-sm font-bold flex gap-2 items-center border border-red-200">
                    <AlertCircle size={18} /> Verifikasi Ditutup
                  </div>
                )}
                <DetailPegawaiCard 
                  selectedItem={selectedItem} isEditingBio={isEditingBio} setIsEditingBio={setIsEditingBio} editedBio={editedBio} setEditedBio={setEditedBio}
                  onBioChange={handleBioChange} onSKPChange={handleSKPChange} skpMapData={{}} isReadOnly={isClosed && userRole === 'satlak'} 
                  onSaveBio={saveBioChanges} onReject={() => setShowRejectModal(true)} 
                  onApprove={() => {
                     if (selectedItem?.status?.toLowerCase() === 'disetujui') {
                          showToast("Berkas ini sudah berstatus Disetujui.", "error");
                     } else {
                         setShowApproveModal(true);
                     }
                  }} 
                  golonganOptions={Object.keys(GOLONGAN_MAP)}
                  onPreviewClick={setPreviewUrl} 
                  userRole={userRole} 
                />
               </div>

              <div className="w-full lg:w-2/3 min-w-0">
                {userRole === 'satlak' ? (
                  <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <div className="flex justify-between items-center mb-5 border-b border-slate-200 pb-3">
                      <h3 className="font-bold text-slate-800 flex items-center gap-2">
                        <FileText size={20} className="text-emerald-600"/> Dokumen Terlampir
                      </h3>
                      {selectedItem.dokumen && selectedItem.dokumen.length > 0 && (
                        <button onClick={handleDownloadSemuaDokumen} disabled={isDownloadingDocs} className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-xs font-bold shadow transition-all disabled:opacity-60">
                           {isDownloadingDocs ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
                          {isDownloadingDocs ? 'Memproses...' : 'Download Semua File'}
                        </button>
                       )}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {selectedItem.dokumen && selectedItem.dokumen.length > 0 ? (
                        selectedItem.dokumen.map((doc, i) => (
                          <button type="button" key={i} onClick={() => setPreviewUrl(doc.url)} className="flex w-full items-center justify-between p-4 rounded-lg border border-slate-200 hover:bg-slate-50 hover:border-emerald-300 transition-all group">
                            <div className="flex items-center gap-3 overflow-hidden">
                              <div className="p-2 bg-emerald-100 rounded text-emerald-600"><FileText size={16} /></div>
                              <span className="text-sm font-bold text-slate-700 group-hover:text-emerald-700 truncate">{doc.nama || `Lampiran ${i+1}`}</span>
                            </div>
                            <Eye size={16} className="text-slate-400 group-hover:text-emerald-600 flex-shrink-0" />
                          </button>
                        ))
                       ) : (
                        <div className="col-span-2 text-center p-8 text-sm text-slate-400 bg-slate-50 rounded-xl border border-dashed">Pegawai ini belum mengunggah dokumen persyaratan.</div>
                      )}
                    </div>
                   </div>
                ) : (
                  <div className="w-full overflow-x-auto bg-slate-200 p-4 sm:p-8 rounded-xl border border-slate-300 shadow-inner custom-scrollbar">
                    <div className="min-w-[210mm] mx-auto pointer-events-none opacity-90 transition-transform py-10">
<TabelPreviewPAK calculation={calculateData(editedBio || selectedItem)} selectedItem={editedBio || selectedItem} nomorSurat={selectedItem.nomor_surat || "...../KG.04.04"} isDraft={false} forPrint={false} tanggalTtd={tanggalTtd} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
         )}
      </div>
    </>
  );
};

export default VerifikasiPAK;


